// Mock data for KiberUP cybersecurity website

export const mockServices = {
  tr: [
    {
      id: 1,
      title: "Pentest Service",
      description: "Sistemlerinizin güvenlik açıklarını tespit etmek için kapsamlı penetrasyon testleri gerçekleştiriyoruz. Gerçek saldırganların kullandığı yöntemlerle sisteminizi test ederek, potansiyel güvenlik risklerini önceden belirliyoruz.",
      features: ["Manuel ve otomatik test kombinasyonu", "Detaylı güvenlik raporu", "Düzeltme önerileri", "Risk değerlendirmesi"],
      icon: "Shield"
    },
    {
      id: 2,
      title: "Web Application Security Tests",
      description: "Web uygulamalarınızın OWASP Top 10 ve diğer güvenlik standartlarına uygunluğunu test ediyoruz. SQL injection, XSS, CSRF gibi yaygın güvenlik açıklarını tespit ederek uygulamalarınızı güvenli hale getiriyoruz.",
      features: ["OWASP Top 10 kontrolü", "API güvenlik testleri", "Kimlik doğrulama testleri", "Session yönetimi analizi"],
      icon: "Globe"
    },
    {
      id: 3,
      title: "Cyber Threat Intelligence",
      description: "Siber tehdit istihbaratı hizmetlerimizle organizasyonunuzu gelecekteki saldırılara karşı hazırlıyoruz. Güncel tehdit verilerini analiz ederek proaktif güvenlik stratejileri geliştiriyoruz.",
      features: ["Tehdit analizi ve raporlama", "Indicator of Compromise (IoC) tespiti", "Risk değerlendirmesi", "Stratejik güvenlik planlaması"],
      icon: "Eye"
    },
    {
      id: 4,
      title: "Malware Analysis",
      description: "Zararlı yazılımları derinlemesine analiz ederek, sisteminize nasıl sızdığını ve ne tür zararlar verebileceğini tespit ediyoruz. Malware'in davranış analizi ile etkili koruma stratejileri geliştiriyoruz.",
      features: ["Static ve dynamic analiz", "Sandbox ortamında test", "Reverse engineering", "IOC çıkarımı"],
      icon: "Bug"
    },
    {
      id: 5,
      title: "Static Code Analysis",
      description: "Kaynak kodunuzu statik analiz araçlarıyla tarayarak güvenlik açıklarını kaynak seviyesinde tespit ediyoruz. Kodlama aşamasında güvenlik standartlarına uygunluğu sağlıyoruz.",
      features: ["Otomatik kod tarama", "Güvenlik standartları kontrolü", "False positive eliminasyonu", "Developer training"],
      icon: "Code"
    },
    {
      id: 6,
      title: "DDoS Tests",
      description: "Sistemlerinizin DDoS saldırılarına karşı dayanıklılığını test ediyoruz. Farklı saldırı senaryolarıyla altyapınızın kapasitesini ölçerek, gerekli güvenlik önlemlerini belirliyoruz.",
      features: ["Layer 3/4/7 DDoS testleri", "Kapasiye analizi", "Mitigation stratejileri", "İyileştirme önerileri"],
      icon: "Zap"
    },
    {
      id: 7,
      title: "5G Security",
      description: "5G ağ altyapınızın güvenliğini yeni nesil teknolojilere uygun standartlarla test ediyoruz. 5G'nin getirdiği yeni güvenlik risklerini analiz ederek koruma stratejileri geliştiriyoruz.",
      features: ["5G Core güvenlik testleri", "Edge computing güvenliği", "Network slicing analizi", "IoT device security"],
      icon: "Radio"
    }
  ],
  uz: [
    {
      id: 1,
      title: "Pentest Xizmati",
      description: "Tizimlariingizning xavfsizlik zaifliklarini aniqlash uchun keng ko'lamli penetratsiya testlarini amalga oshiramiz. Haqiqiy tajovuzkorlar ishlatiladigan usullar bilan tizimingizni sinab, potentsial xavfsizlik xavflarini oldindan aniqlaymiz.",
      features: ["Qo'lda va avtomatik test kombinatsiyasi", "Batafsil xavfsizlik hisoboti", "Tuzatish takliflari", "Xavf baholash"],
      icon: "Shield"
    },
    {
      id: 2,
      title: "Web Ilovalar Xavfsizlik Testlari",
      description: "Web ilovalaringizning OWASP Top 10 va boshqa xavfsizlik standartlariga muvofiqligini sinab ko'ramiz. SQL injection, XSS, CSRF kabi keng tarqalgan xavfsizlik zaifliklarini aniqlab, ilovalaringizni xavfsiz holatga keltiramiz.",
      features: ["OWASP Top 10 nazorati", "API xavfsizlik testlari", "Shaxsni tasdiqlash testlari", "Session boshqaruvi tahlili"],
      icon: "Globe"
    },
    {
      id: 3,
      title: "Kiber Tahdid Razvedkasi",
      description: "Kiber tahdid razvedkasi xizmatlarimiz bilan tashkilotingizni kelajakdagi hujumlarga qarshi tayyorlaymiz. Dolzarb tahdid ma'lumotlarini tahlil qilib, proaktiv xavfsizlik strategiyalarini ishlab chiqamiz.",
      features: ["Tahdid tahlili va hisobot berish", "Indicator of Compromise (IoC) aniqlash", "Xavf baholash", "Strategik xavfsizlik rejalashtirish"],
      icon: "Eye"
    },
    {
      id: 4,
      title: "Zararli Dastur Tahlili",
      description: "Zararli dasturlarni chuqur tahlil qilib, ular tizimingizga qanday kirib borishi va qanday zarar yetkazishi mumkinligini aniqlaymiz. Malware'ning xatti-harakatlari tahlili bilan samarali himoya strategiyalarini ishlab chiqamiz.",
      features: ["Statik va dinamik tahlil", "Sandbox muhitida test", "Teskari muhandislik", "IOC chiqarish"],
      icon: "Bug"
    },
    {
      id: 5,
      title: "Statik Kod Tahlili",
      description: "Manba kodingizni statik tahlil vositalari bilan skanerlash orqali xavfsizlik zaifliklarini manba darajasida aniqlaymiz. Kodlash bosqichida xavfsizlik standartlariga muvofiqlikni ta'minlaymiz.",
      features: ["Avtomatik kod skanerlash", "Xavfsizlik standartlari nazorati", "Yolg'on ijobiy eliminatsiya", "Dasturchi treningi"],
      icon: "Code"
    },
    {
      id: 6,
      title: "DDoS Testlari",
      description: "Tizimlariingizning DDoS hujumlarga qarshi chidamliligini sinab ko'ramiz. Turli hujum stsenariyalari bilan infratuzilmangizning quvvatini o'lchab, zarur xavfsizlik choralarini aniqlaymiz.",
      features: ["Layer 3/4/7 DDoS testlari", "Quvvat tahlili", "Mitigation strategiyalari", "Yaxshilash takliflari"],
      icon: "Zap"
    },
    {
      id: 7,
      title: "5G Xavfsizlik",
      description: "5G tarmoq infratuzilmangizning xavfsizligini yangi avlod texnologiyalariga mos standartlar bilan sinab ko'ramiz. 5G'ning olib kelgan yangi xavfsizlik xavflarini tahlil qilib, himoya strategiyalarini ishlab chiqamiz.",
      features: ["5G Core xavfsizlik testlari", "Edge computing xavfsizligi", "Network slicing tahlili", "IoT qurilma xavfsizligi"],
      icon: "Radio"
    }
  ],
  ru: [
    {
      id: 1,
      title: "Пентест Сервис",
      description: "Мы проводим комплексные тесты на проникновение для выявления уязвимостей безопасности ваших систем. Тестируя вашу систему методами, используемыми реальными злоумышленниками, мы заранее определяем потенциальные риски безопасности.",
      features: ["Комбинация ручного и автоматического тестирования", "Детальный отчет о безопасности", "Рекомендации по исправлению", "Оценка рисков"],
      icon: "Shield"
    },
    {
      id: 2,
      title: "Тесты Безопасности Веб-Приложений",
      description: "Мы тестируем соответствие ваших веб-приложений OWASP Top 10 и другим стандартам безопасности. Выявляя распространенные уязвимости безопасности, такие как SQL injection, XSS, CSRF, мы делаем ваши приложения безопасными.",
      features: ["Проверка OWASP Top 10", "Тесты безопасности API", "Тесты аутентификации", "Анализ управления сессиями"],
      icon: "Globe"
    },
    {
      id: 3,
      title: "Киберразведка Угроз",
      description: "С нашими услугами киберразведки угроз мы готовим вашу организацию к будущим атакам. Анализируя актуальные данные об угрозах, мы разрабатываем проактивные стратегии безопасности.",
      features: ["Анализ угроз и отчетность", "Выявление Indicator of Compromise (IoC)", "Оценка рисков", "Стратегическое планирование безопасности"],
      icon: "Eye"
    },
    {
      id: 4,
      title: "Анализ Вредоносного ПО",
      description: "Глубоко анализируя вредоносное программное обеспечение, мы определяем, как оно проникло в вашу систему и какой ущерб может нанести. С анализом поведения малвари мы разрабатываем эффективные стратегии защиты.",
      features: ["Статический и динамический анализ", "Тестирование в песочнице", "Обратная инженерия", "Извлечение IOC"],
      icon: "Bug"
    },
    {
      id: 5,
      title: "Статический Анализ Кода",
      description: "Сканируя ваш исходный код инструментами статического анализа, мы выявляем уязвимости безопасности на уровне исходного кода. Обеспечиваем соответствие стандартам безопасности на этапе кодирования.",
      features: ["Автоматическое сканирование кода", "Проверка стандартов безопасности", "Устранение ложных срабатываний", "Обучение разработчиков"],
      icon: "Code"
    },
    {
      id: 6,
      title: "DDoS Тесты",
      description: "Мы тестируем устойчивость ваших систем к DDoS-атакам. Измеряя мощность вашей инфраструктуры различными сценариями атак, мы определяем необходимые меры безопасности.",
      features: ["Тесты DDoS уровня 3/4/7", "Анализ мощности", "Стратегии митигации", "Рекомендации по улучшению"],
      icon: "Zap"
    },
    {
      id: 7,
      title: "Безопасность 5G",
      description: "Мы тестируем безопасность вашей сетевой инфраструктуры 5G стандартами, подходящими для технологий нового поколения. Анализируя новые риски безопасности, привносимые 5G, мы разрабатываем стратегии защиты.",
      features: ["Тесты безопасности 5G Core", "Безопасность edge computing", "Анализ network slicing", "Безопасность IoT устройств"],
      icon: "Radio"
    }
  ],
  en: [
    {
      id: 1,
      title: "Pentest Service",
      description: "We perform comprehensive penetration tests to detect security vulnerabilities in your systems. By testing your system with methods used by real attackers, we identify potential security risks in advance.",
      features: ["Manual and automatic test combination", "Detailed security report", "Remediation recommendations", "Risk assessment"],
      icon: "Shield"
    },
    {
      id: 2,
      title: "Web Application Security Tests",
      description: "We test your web applications' compliance with OWASP Top 10 and other security standards. By detecting common security vulnerabilities like SQL injection, XSS, CSRF, we make your applications secure..",
      features: ["OWASP Top 10 check", "API security tests", "Authentication tests", "Session management analysis"],
      icon: "Globe"
    },
    {
      id: 3,
      title: "Cyber Threat Intelligence",
      description: "With our cyber threat intelligence services, we prepare your organization against future attacks. By analyzing current threat data, we develop proactive security strategies.",
      features: ["Threat analysis and reporting", "Indicator of Compromise (IoC) detection", "Risk assessment", "Strategic security planning"],
      icon: "Eye"
    },
    {
      id: 4,
      title: "Malware Analysis",
      description: "By deeply analyzing malicious software, we determine how it infiltrated your system and what kind of damage it can cause. With malware behavior analysis, we develop effective protection strategies.",
      features: ["Static and dynamic analysis", "Sandbox testing", "Reverse engineering", "IOC extraction"],
      icon: "Bug"
    },
    {
      id: 5,
      title: "Static Code Analysis",
      description: "By scanning your source code with static analysis tools, we detect security vulnerabilities at the source level. We ensure compliance with security standards during the coding phase.",
      features: ["Automatic code scanning", "Security standards check", "False positive elimination", "Developer training"],
      icon: "Code"
    },
    {
      id: 6,
      title: "DDoS Tests",
      description: "We test your systems' resilience against DDoS attacks. By measuring your infrastructure's capacity with different attack scenarios, we determine necessary security measures.",
      features: ["Layer 3/4/7 DDoS tests", "Capacity analysis", "Mitigation strategies", "Improvement recommendations"],
      icon: "Zap"
    },
    {
      id: 7,
      title: "5G Security",
      description: "We test your 5G network infrastructure security with standards suitable for next-generation technologies. By analyzing new security risks brought by 5G, we develop protection strategies.",
      features: ["5G Core security tests", "Edge computing security", "Network slicing analysis", "IoT device security"],
      icon: "Radio"
    }
  ]
};

export const mockTrainings = {
  tr: [
    {
      id: 1,
      title: "Pratik Web Güvenliği (Hacker Gözüyle)",
      description: "Web uygulamalarını bir güvenlik araştırmacısı / etik hacker perspektifiyle inceleyin. OWASP Top-10 konularını gerçek dünya vakalarıyla öğrenin.",
      fullDescription: `Bu uygulamalı eğitimde web uygulamalarını bir güvenlik araştırmacısı / etik hacker perspektifiyle inceliyoruz. Katılımcılar OWASP Top-10 konularını gerçek dünya vaka çalışmaları üzerinden hem nasıl istismar edilir hem de nasıl kapatılır açılarıyla öğrenecekler. Eğitim teoriyi kısa ve öz tutup hemen ardından canlı demolar ve uygulamalı laboratuvarlarla pekiştiriyoruz.

İçerik & Yöntemler:

• Burp Suite ile trafik yakalama, proxy akışları ve repeater uygulamaları.
• Yetkilendirme ve oturum yönetimi zafiyetlerinin keşfi (IDOR, broken auth).
• İş mantığı hatalarının tespiti ve exploit senaryoları.
• SQLi, XSS, SSRF gibi kritik açıkların keşfi, doğrulanması ve PoC hazırlanması.
• Bug-bounty tarzı sandbox laboratuvarlarında pratik uygulamalar ve raporlama.
• Teknik bulguların yönetici-odaklı özetlere ve uygulanabilir eylem planlarına dönüştürülmesi.

Eğitim Akışı:
Her modül: kısa teori → canlı demo → bireysel / takım lab uygulaması. Kurs sonunda her katılımcı en az bir PoC ve kısa teknik rapor sunar; eğitmenlerden uygulamalı geribildirim alır.

Kazanımlar:

• OWASP Top-10 başlıklarını pratikte tespit ve doğrulama.
• Tekrarlanabilir PoC ve etkili teknik rapor hazırlama.
• Saldırı zincirlerini analiz edip öncelikli düzeltme adımları belirleyebilme.

Kime Uygun / Önkoşul:
Web geliştiriciler, güvenlik mühendisleri, pentester adayları ve bug-bounty katılımcıları. Temel HTTP, HTML ve SQL bilgisi önerilir.

Format & Süre:
Canlı oturumlar + lab erişimi. Değerlendirme: PoC + kısa teknik rapor. Süre: 30–45 saat (modüler; haftasonu veya yoğunlaştırılmış seçenekler).`,
      duration: "30-45 saat",
      level: "Orta-İleri",
      format: "Live + Lab",
      icon: "Globe"
    },
    {
      id: 2,
      title: "Pratik Tersine Mühendislik (RE & Malware)",
      description: "Tersine mühendislik ve malware analizinin temel zihniyetini ve yöntemlerini öğrenin. İkili dosyaların iç yapısını açmayı, assembly dilini okunabilir hale getirmeyi öğreneceksiniz.",
      fullDescription: `Bu uygulamalı eğitim, katılımcılara tersine mühendislik (reverse engineering) ve kötü amaçlı yazılım (malware) analizinin temel zihniyetini ve yöntemlerini öğretmeyi amaçlar. Kurs, "kodu yazmak yerine davranışı anlamak" yaklaşımını benimser: ikili (binary) dosyaların iç yapısını açmayı, assembly dilini okunabilir hale getirmeyi ve bir örneğin sistem üzerindeki etkisini güvenli ortamda analiz etmeyi öğreneceksiniz. Örnek bir zararlı yazılım baştan sona analiz edilecek.

Neler öğreneceksiniz (konu başlıkları):

• Tersine mühendisliğin temelleri: PE/ELF formatları, giriş noktası, bağımlılıklar ve temel ikili yapılar.
• Assembly okuma pratikleri (x86/x86_64): mantık çıkarma, fonksiyon sınırları, çağrı/return analizleri — korkutmadan, adım adım.
• Statik analiz yöntemleri: disassembler/decompiler (ör. Ghidra/IDA) kullanımı, kod akışı ve veri akışı analizi.
• Dinamik analiz ve davranış incelemesi: sandbox/VM tabanlı çalıştırma, proses/işlem takibi, API çağrıları ve I/O gözlemi.
• Packer/obfuscation tespiti ve temel yaklaşımlar.
• Hafıza analizi ve runtime izleri: bellek dökümü inceleme (temel düzey).
• PoC hazırlama, bulguların sınıflandırılması ve teknik raporlama.
• Güvenlik, etik ve yasal sınırlar: analiz ortamının izolasyonu, güvenlik protokolleri ve responsible disclosure süreçleri.

Araçlar & kaynaklar (örnek):
Ghidra / IDA / Radare2 (statik), x64dbg / OllyDbg (dinamik), Binary Ninja (opsiyonel), Cuckoo veya benzeri sandbox çözümleri, procmon/strace, Sysinternals araçları.

Eğitim formatı & metodoloji:
Kurs pratik-ağırlıklıdır. Her modülde kısa teori → canlı demo → bireysel/takım laboratuvar uygulaması döngüsü uygulanır. Tüm çalışmalar izole edilmiş laboratuvar ortamında (sanal makineler, izole ağ, snapshot) yapılır; gerçek örneklerle davranış analizi yapılır, ancak asla kötü amaçlı kullanım için yönergeler verilmez.

Öğrenme çıktıları (kazanımlar):

• İkili dosya formatlarını ve temel assembly yapılarını anlayıp yorumlayabilecek;
• Statik ve dinamik analiz ile bir örneğin temel davranışını tespit edip sınıflandırabilecek;
• Basit PoC'lar ve teknik bulgular üretebilecek; bunları yönetici ve teknik seviyede raporlayabilecek;
• Güvenli analiz ortamı kurma prensiplerini (izolasyon, snapshot, ağ kısıtlama) uygulayabilecek.

Kime uygun:
Malware analizi veya tersine mühendislik alanına girmek isteyen güvenlik mühendisleri, adli bilişim/pentest ekipleri, güvenlik meraklısı geliştiriciler ve siber istihbarat uzmanları.

Önkoşullar:
Temel programlama bilgisi (C/C++ veya benzeri), temel işletim sistemi bilgisi ve komut-satırı tecrübesi önerilir.

Değerlendirme & çıktı:
Kurs sonunda katılımcılar küçük bir analiz projesi teslim eder: bir sample'ın güvenli ortamda incelenmesi, tespit edilen davranışların teknik özeti ve yönetici-dostu kısa rapor.

Süre & düzen:
Toplam 30–50 saat (modüler, 4–6 hafta; haftasonu veya yoğunlaştırılmış seçenekler).

Etik & güvenlik taahhüdü:
Eğitim sürecinde kullanılan örnekler yalnızca analiz ve eğitim amaçlıdır; katılımcılardan etik kurallara uymaları, analiz ortamlarını izole tutmaları ve bulguları sorumlu şekilde paylaşmaları beklenir.`,
      duration: "30-50 saat",
      level: "İleri",
      format: "Live + Lab",
      icon: "Cog"
    },
    {
      id: 3,
      title: "Pratik Etik Hacker (Uçtan Uca Pentest)",
      description: "Uçtan uca bir penetrasyon testinin tüm aşamalarını gerçek dünya kurallarıyla (RoE) deneyimleyin. Ekip koordinasyonu, etik farkındalık ve savunma odaklı düşünme becerileri kazanın.",
      fullDescription: `Bu eğitim, size uçtan uca bir penetrasyon testinin tüm aşamalarını gerçek dünya kurallarıyla (Rules of Engagement, RoE) uygulamalı olarak deneyimletmeyi ve aynı zamanda ekip içinde koordinasyon, etik farkındalık ve savunma odaklı düşünme becerileri kazandırmayı hedeflemektedir. Teori kısa ve öz tutulacak, canlı demolar ve takım laboratuvarları ile pekiştirilecek ve sonunda gerçekçi bir mini red-team senaryosu ile öğrendiklerinizi uygulamaya dökeceksiniz.

Eğitimin hedefi:

• Katılımcılara RoE ile uyumlu uçtan uca pentest sürecini uygulama becerisi kazandırmak
• Ekip içi görev dağılımı, iletişim ve operasyon koordinasyonu yetkinliklerini geliştirmek
• Savunma odaklı bakış açısı ve etik sorumluluk bilinci oluşturmak

Konu başlıkları (yüksek seviye):

• RoE ve izin süreçleri: kapsam tanımlama, izin mekanizmaları ve yasal/etik sınırlar
• Keşif (Recon): hedef belirleme, OSINT ve varlık envanteri oluşturma
• Tarama ve zafiyet keşfi: aktif ve pasif tarama, servis/port keşfi, otomatik ve manuel doğrulama
• Doğrulama ve etki analizi: zafiyetlerin güvenli doğrulanması ve olası etkilerinin değerlendirilmesi
• Exploit senaryoları ve simülasyon: kontrollü ortamlarda senaryo bazlı doğrulama ve tartışma
• Pivoting ve lateral hareket (simülasyon): erişimin nasıl genişleyebileceğinin tespiti ve etkilerinin analizi
• Raporlama: teknik bulguların detaylandırılması ve yönetici özeti hazırlanması
• Mini red-team senaryosu: ekip planlama, yürütme ve sonuçların raporlanması

Teknik ve aksiyon odaklı uygulamalar:

• Gerçekçi OSINT görevi: ekipler sınırlı süre içinde açık kaynak bulguları toplayıp önceliklendirecek
• Ağ keşif challenge: izole laboratuvarda hedef ağın haritasını çıkarma ve kritik varlıkları tespit etme
• AD haritalama senaryosu: Active Directory bilgisi toplama ve saldırı yüzeyini modelleme (sadece tespit/raporlama)
• Pivoting & erişim genişletme simülasyonu: lateral keşif ve erişim yayılımını planlayıp raporlama
• Kısa "live" tatbikat: takımlar hızlı plan kurup saldırı senaryosu yürütecek
• Sosyal mühendislik masaüstü senaryosu: phishing farkındalığı ve raporlama
• Log analizi & tespit testi: SIEM/log örneklerini inceleme ve false-positive'leri ayrıştırma
• Ransomware-simulasyon etkisi: iş süreçlerine etkisinin analizi ve öncelikli müdahale adımları
• Capture-the-flag tarzı kısa görevler: puan-tabanlı değerlendirme ile motivasyon artırma

Eğitim formatı ve metodoloji:
Kısa teori, canlı demo ve takım tabanlı laboratuvar uygulamaları döngüsüyle ilerler. Tüm çalışmalar izole edilmiş sanal laboratuvarlarda yürütülür. Mini red-team senaryosu proje bazlıdır; ekipler plan yapar, uygular ve rapor sunar.

Öğrenme çıktıları (kazanımlar):

• RoE çerçevesinde bir pentest sürecini baştan sona planlayıp yürütebilme
• Keşif, tarama ve doğrulama adımlarını güvenli biçimde uygulayıp bulguları önceliklendirme
• Teknik bulguları hem teknik ekipler hem de yöneticiler için anlaşılır raporlara dönüştürme
• Ekip içi rol dağılımı, koordinasyon ve iletişim becerilerini geliştirme
• Red-team/blue-team dinamiklerini deneyimleme ve savunma odaklı perspektif kazanma

Kime uygun:
Pentest öğrenmek isteyenler, güvenlik mühendisleri, SOC/IR uzmanları, ağ ve sistem yöneticileri, siber güvenlik alanında kariyer hedefleyen öğrenciler ve yeni mezunlar.

Önkoşullar:
Temel ağ bilgisi (TCP/IP), temel işletim sistemi bilgisi ve komut satırı deneyimi.

Değerlendirme:
Her ekip küçük bir pentest projesi sunacaktır: kapsam, keşif bulguları, doğrulanmış zafiyetler, etki değerlendirmesi, teknik rapor ve yönetici özeti.

Süre & düzen:
Toplam 24–40 saat (modüler; hafta sonu blokları veya yoğunlaştırılmış program).

Etik & güvenlik taahhüdü:
Eğitim boyunca RoE ilkelerine tam uyum zorunludur. Laboratuvar ortamları izole edilmiş ve sadece eğitim amaçlı kullanılır.`,
      duration: "24-40 saat",
      level: "Orta-İleri",
      format: "Live + Lab",
      icon: "Users"
    },
    {
      id: 4,
      title: "Pratik Siber İstihbarat (OSINT & Threat Hunting)",
      description: "Hedef profilleme, etik veri toplama ve bulguları MITRE ATT&CK matrisi üzerinden anlamlandırmayı öğrenin. Savunma ve istihbarat odaklı pratik yetkinlikler kazanın.",
      fullDescription: `Bu uygulamalı eğitimde hedef profilleme, etik veri toplama ve elde edilen bulguları MITRE ATT&CK matrisi üzerinden anlamlandırma süreçlerini öğreneceksiniz. Teori kısa ve hedefe yönelik olacak; canlı demolar, pratik OSINT görevleri ve threat hunting senaryolarıyla bilgiler pekiştirilecek. Eğitim sonunda hem savunma hem de istihbarat odaklı pratik yetkinlikler kazanmış olacaksınız.

Eğitimin hedefi:

• Katılımcılara hedef odaklı profilleme ve etik veri toplama süreçlerini uygulamalı olarak öğretmek
• Toplanan verileri MITRE ATT&CK çerçevesinde analiz edip tehdit aktörlerinin TTP'larını belirleyebilme yeteneği sağlamak
• SIEM ve log kaynakları üzerinden etkin threat hunting pratiklerini uygulayabilme ve bulguları operasyonel aksiyona dönüştürebilme becerisi kazandırmak

Konu başlıkları (yüksek seviye):

• OSINT temelleri: hedef belirleme, kaynak sınıflandırma, açık ve kapalı webden etik veri toplama yöntemleri
• Araçlar ve otomasyon: Maltego, SpiderFoot, Shodan, theHarvester, Google Dorking, OSINT frameworkleri ve API kullanımı
• Veri zenginleştirme ve doğrulama: çoklu kaynaktan doğrulama, PII/false-positive yönetimi ve güvenilirlik değerlendirmesi
• Dark web ve forum gözlemi: etik sınırlar içinde izleme ve işlenebilir istihbarata dönüştürme
• MITRE ATT&CK ile eşleme: IOCs ve davranış kalıplarını ATT&CK tekniklerine haritalama ve tehdit profili çıkarma
• Threat hunting pratikleri: hipotez oluşturma, SIEM/sorgu geliştirme, IOC avı ve av sonrası analiz
• Tehdit raporlama: teknik bulguların TI feed, IOC listeleri, TTP raporları ve yönetici özetine dönüştürülmesi

Teknik ve aksiyon odaklı uygulamalar:

• Hedef profilleme görevi: sınırlı süre içinde hedef kuruluş veya persona için zengin profilleme ve önceliklendirme
• Shodan ve IoT keşif challenge: internetten erişilebilir varlıkların tespiti ve risk değerlendirmesi
• Dark web tarama senaryosu: izole ortamda forum/post takip ve elde edilen verinin sınıflandırılması
• MITRE mapping atölyesi: gerçek vaka verisi üzerinden ATT&CK eşlemesi ve TTP raporu oluşturma
• SIEM hunting drill: örnek log dataset'i üzerinde sorgu yazma, hipotez doğrulama ve IOC çıkarma
• Threat intelligence enrichment: otomatik/manuel zenginleştirme ile IOC'leri doğrulama ve taksonomiye yerleştirme
• Capture-the-IOC: kısa görevlerle kritik IOC'leri tespit etme, skorlayıp raporlama

Eğitim formatı ve metodoloji:
Kısa teori, canlı demo ve bireysel/takım görevleriyle ilerler. Pratikler izole edilmiş analiz ve test ortamlarında (sandbox, VM) gerçekleştirilir. Her modülde gerçek dünya verisiyle çalışma, araç entegrasyonları ve API kullanım örnekleri gösterilir.

Öğrenme çıktıları (kazanımlar):

• Hedef odaklı OSINT sürecini planlayıp uygulayabilecek, toplanan veriyi doğrulayıp önceliklendirebileceksiniz
• MITRE ATT&CK'e uygun olarak TTP ve IOC analizleri yapabilecek, tehdit aktörü profili çıkarabileceksiniz
• SIEM/log verileri üzerinde threat hunting gerçekleştirebilecek ve etkili arama sorguları yazabileceksiniz
• Elde ettiğiniz istihbaratı operasyonel aksiyona dönüştürebilecek ve raporlayabileceksiniz
• Teknik bulguları hem operasyon ekiplerine hem yönetime anlaşılır şekilde sunabileceksiniz

Kime uygun:
Siber istihbarat, SOC ve IR ekiplerinde çalışanlar, güvenlik analistleri ve threat hunter'lar, SOC operatörleri ve olay müdahale ekipleri, OSINT/CTI alanında uzmanlaşmak isteyen güvenlik profesyonelleri.

Önkoşullar:
Temel ağ ve güvenlik bilgisi (TCP/IP, temel log kavramları), komut satırı ve temel script bilgisi (Python/Bash) önerilir.

Değerlendirme:
Katılımcılar takım veya bireysel olarak kısa OSINT/profil görevleri tamamlayacak ve elde edilen IOCs, zenginleştirme raporu ve MITRE eşlemesi sunacak.

Süre ve düzen:
Toplam 18–30 saat aralığında modüler yapı (örn. 3 hafta sonu veya 5 akşam oturumu).

Etik & güvenlik taahhüdü:
Tüm veri toplama faaliyetleri etik ve yasal çerçevede, izinli ve sorumlu biçimde yürütülecektir. Toplanan hassas verilerin korunması, PII yönetimi ve sorumlu ifşa süreçlerine uyum zorunludur.`,
      duration: "18-30 saat",
      level: "Orta",
      format: "Live + Lab",
      icon: "Search"
    },
    {
      id: 5,
      title: "Linux & Windows Sıkılaştırma (Saldırgan Gibi Düşün, Savunmayı Doğru Kur)",
      description: "Saldırgan bakış açısıyla zafiyetleri tespit edin ve sistemleri adım adım sıkılaştırın. Gerçek saldırı senaryolarını anlayın ve savunmayı doğru kurun.",
      fullDescription: `Bu uygulamalı eğitim, katılımcılara hem Linux hem de Windows işletim sistemlerinde saldırgan bakış açısıyla zafiyetleri tespit etmeyi ve ardından bu sistemleri adım adım "sıkılaştırmayı" öğretir. Teori kısa tutulur; asıl odak, gerçek saldırı senaryolarını anlamak ve bunlara karşı savunmayı doğru kurmaktır. Katılımcılar, bir saldırganın sistemde nasıl hareket ettiğini görür, ardından aynı sistemi profesyonel bir güvenlik mühendisi gibi korumayı öğrenir.

Eğitimin hedefi:

• Linux ve Windows ortamlarında saldırı yüzeylerini tanımlama ve azaltma becerisi kazandırmak
• Güvenlik açıklarını proaktif şekilde tespit edip savunmayı güçlendirmek
• Gerçek saldırı tekniklerini tanıyıp etkili sıkılaştırma politikaları geliştirmek
• "Saldırgan gibi düşün, güvenlikçi gibi savun" yaklaşımını kazandırmak

Konu başlıkları:

• Hardening temel prensipleri
• Linux güvenliği: dosya izinleri, sudo yapılandırması, SSH güvenliği, log analizi
• Windows güvenliği: Active Directory, GPO, kullanıcı yetkilendirme, PowerShell güvenliği
• Servis bazlı sıkılaştırma: Apache/IIS, MySQL/MSSQL, RDP/SSH yapılandırmaları
• Zayıf konfigürasyon tespiti ve giderilmesi
• Privilege escalation ve persistence önlemleri
• Firewall, network segmentasyonu ve minimal izin prensibi
• Olay tespiti, log izleme ve audit araçları
• CIS Benchmark ve STIG uyumlu politika oluşturma

Teknik uygulamalar:

• Zafiyetli sanal makinede saldırı simülasyonu ve savunma yapılandırması
• SSH brute-force tespiti ve erişim kısıtlaması
• PowerShell log analizi
• Local privilege escalation vektörlerinin kapatılması
• Linux log analiziyle yetkisiz erişim tespiti
• CIS Benchmark testi ve rapor değerlendirmesi
• Red-Team vs Blue-Team mini senaryosu

Eğitim formatı:
Teori + canlı demo + laboratuvar uygulamaları. Katılımcılar kendi sanal makinelerinde çalışır. Gerçek saldırı örnekleri güvenli laboratuvar ortamında gösterilir.

Kazanımlar:

• Linux ve Windows'ta zafiyetleri tespit edip kapatabilme
• Uluslararası standartlara göre sistem hardening uygulayabilme
• Log analizi ve saldırı izleme süreçlerini yönetebilme
• Kurumsal güvenlik checklisti oluşturabilme

Kime uygun:
Sistem yöneticileri, siber güvenlik mühendisleri, SOC/IR ekipleri, pentester ve Blue/Red-Team katılımcıları.

Süre:
20–30 saat (4 gün yoğun veya 6 akşam modülü).

Etik ve güvenlik:
Tüm simülasyonlar izole ortamlarda yapılır. Gerçek sistemlere müdahale yasaktır. Eğitim yalnızca savunma ve farkındalık amaçlıdır.`,
      duration: "20-30 saat",
      level: "Orta",
      format: "Live + Lab",
      icon: "Shield"
    },
    {
      id: 6,
      title: "Pratik Mobil Güvenlik (Android & iOS)",
      description: "Android ve iOS uygulamalarının iç yapısını keşfedin, saldırgan tekniklerini öğrenin ve uygulamaları güvenli hale getirin. Mobil pentest ve güvenli kod geliştirme becerilerini birleştirin.",
      fullDescription: `Bu uygulamalı eğitim, katılımcılara mobil uygulamalarda güvenlik testlerinin nasıl yapılacağını, zafiyetlerin nasıl tespit edilip giderileceğini ve güvenli uygulama geliştirme prensiplerini öğretir. Katılımcılar, saldırgan bakış açısından mobil uygulamaların nasıl analiz edildiğini öğrenirken, aynı zamanda savunma odaklı geliştirme ve güvenli yapılandırma tekniklerini de deneyimleyeceklerdir. Eğitim boyunca gerçek APK ve IPA dosyaları üzerinden analiz, tersine mühendislik, veri manipülasyonu ve güvenli kodlama senaryoları uygulanır.

Eğitimin hedefi:

• Android ve iOS ortamlarında mobil uygulama sızma testi yapabilme becerisi kazandırmak
• Veri güvenliği, kimlik doğrulama, yetkilendirme ve şifreleme hatalarını tanımak
• OWASP Mobile Top 10 çerçevesinde açıkları analiz edip kapatmak
• Güvenli mobil kodlama ve hardening prensiplerini öğretmek
• Saldırgan ve savunmacı bakış açılarını birleştirmek

Konu başlıkları:

• Mobil güvenlik temelleri ve tehdit modeli
• OWASP Mobile Top 10 uygulamaları
• Android güvenliği: APK analizi, Smali, SSL pinning, WebView, root detection
• iOS güvenliği: IPA inceleme, Keychain, jailbreak tespiti, sandbox, secure storage
• Ağ güvenliği: HTTPS, MITM, proxy analizi, Burp Suite, Frida, Objection
• Güvenli kodlama: girdi doğrulama, veri şifreleme, token yönetimi
• Mobil hardening: imzalama, obfuscation, MDM politikaları

Teknik uygulamalar:

• Gerçek APK ve IPA dosyaları üzerinde test
• Decompile ve reverse engineering (APKTool, JADX, Hopper)
• SSL Pinning bypass, root ve jailbreak detection testleri
• Burp Suite ve Frida ile trafik manipülasyonu
• Credential capture ve düzeltme egzersizleri
• Mobil API güvenlik testleri
• Secure coding uygulamaları ve Blue-Team senaryosu

Eğitim formatı:
Teori, canlı demo ve laboratuvar egzersizleri. Katılımcılara sanal laboratuvar ve emülatör ortamı sağlanır. Gerçek mobil uygulamalarla "test – düzeltme – yeniden test" döngüsü uygulanır.

Kazanımlar:

• Mobil uygulamalarda güvenlik testleri yapabilme
• OWASP Mobile Top 10 açıklarını tespit edip doğrulama
• SSL Pinning, Root/Jailbreak Detection süreçlerini anlama
• Güvenli kodlama prensiplerini uygulama
• API ve ağ güvenliği kontrollerini kurma
• Uygulama hardening yöntemlerini kullanma

Kime uygun:
Mobil geliştiriciler, güvenlik test uzmanları, SOC ve IR ekipleri, mobil güvenliğe yönelmek isteyen yazılımcılar, siber güvenlik öğrencileri ve yeni mezunlar.

Önkoşullar:
Temel ağ bilgisi (TCP/IP, HTTPS), Android Studio veya benzeri ortam bilgisi, komut satırı tecrübesi.

Değerlendirme:
Katılımcılar zafiyetli bir mobil uygulamayı analiz edip güvenli hale getirir. Final raporu hazırlanır: açıklar, çözümler, çıkarımlar.

Süre:
20–35 saat (4 gün yoğun veya 6 akşam modülü).

Etik ve güvenlik:
Tüm çalışmalar izole ortamlarda yapılır. Gerçek uygulamalara müdahale yasaktır. Eğitim yalnızca savunma ve farkındalık amaçlıdır.`,
      duration: "20-35 saat",
      level: "Orta-İleri",
      format: "Live + Lab",
      icon: "Smartphone"
    }
  ],
  uz: [
    {
      id: 1,
      title: "Amaliy Veb Xavfsizligi (Xaker Nigohi Bilan)",
      description: "Veb-ilovalarni xavfsizlik tadqiqotchisi / etik xaker nigohidan oʻrganing. OWASP Top-10 mavzularini haqiqiy holatlar orqali oʻrganing.",
      fullDescription: `Ushbu amaliy kursda veb-ilovalarni xavfsizlik tadqiqotchisi / etik xaker nigohidan oʻrganamiz. Ishtirokchilar OWASP Top-10 mavzularini haqiqiy holatlar orqali ham qanday ekspluatatsiya qilinadi, ham qanday bartaraf etiladi jihatidan oʻrganadilar. Nazariya qisqa va aniq, soʻngra darhol jonli demo va amaliy laboratoriyalar bilan mustahkamlanadi.

Mavzular va usullar:

• Burp Suite orqali trafikni tutish, proxy oqimlari va repeater mashqlari.
• Avtorizatsiya va sessiya boshqaruvi zaifliklarini topish (IDOR, broken auth).
• Biznes-mantiqiy xatoliklarni aniqlash va exploit ssenariylari.
• SQLi, XSS, SSRF kabi kritik zaifliklarni aniqlash, tekshirish va PoC yaratish.
• Bug-bounty uslubidagi sandbox laboratoriyalarida amaliy mashgʻulotlar va hisobot tayyorlash.
• Texnik topilmalarni rahbarlar uchun tushunarli tavsiyalar va amalga oshirish rejalariga aylantirish.

Kurs Tuzilishi:
Har modul: qisqa nazariya → jonli demo → yakka/tarmoqli lab mashqlari. Kurs oxirida har bir qatnashchi kamida bitta PoC va qisqa texnik hisobot taqdim etadi; murabbiylar amaliy fikr bildiradi.

Oʻquv natijalari:

• OWASP Top-10 zaifliklarini amalda aniqlash va tasdiqlash.
• Takrorlanadigan PoC va samarali texnik hisobotlar tayyorlash.
• Hujum zanjirlarini tahlil qilib ustuvor tuzatish choralarini taklif qilish.

Kimlar uchun / Talablar:
Veb dasturchilar, xavfsizlik muhandislari, pentest boshlovchilar va bug-bounty ishtirokchilari. HTTP, HTML va SQL bo'yicha asosiy bilim tavsiya etiladi.

Format va Davomiyligi:
Jonli sessiyalar + lab kirish. Baholash: PoC + qisqa texnik hisobot. Davomiylik: 30–45 soat (modul bo'yicha; dam olish kunlari yoki intensiv format).`,
      duration: "30-45 soat",
      level: "O'rta-Ilg'or",
      format: "Jonli + Lab",
      icon: "Globe"
    },
    {
      id: 2,
      title: "Amaliy Tersine Mühendislik (RE & Malware)",
      description: "Tersine muhandislik va zararli dastur tahlilining asosiy fikr-va-usullarini oʻrganing. Binary fayllarning ichki tuzilishini ochishni va assembly kodini oʻqilishi oson holga keltirishni oʻrganing.",
      fullDescription: `Ushbu amaliy kurs ishtirokchilarga tersine muhandislik va zararli dastur (malware) tahlilining asosiy fikr-va-usullarini oʻrgatishni maqsad qiladi. Kurs "kod yozishdan ko'ra xulq-atvorni tushunish" yondashuvini qabul qiladi: siz binary fayllarning ichki tuzilishini ochishni, assembly kodini oʻqilishi oson holga keltirishni va namunani xavfsiz muhitda tizimga ta'sirini tahlil qilishni oʻrganasiz. Misol uchun bir zararli dastur boshidan oxirigacha tahlil qilinadi.

Nimalarni oʻrganasiz (mavzular):

• Tersine muhandislik asoslari: PE/ELF formatlari, entry point, bog'liqliklar va asosiy binary tuzilmalar.
• Assembly oʻqish amaliyotlari (x86/x86_64): mantiq chiqarish, funksiyalar chegaralari, chaqiriq/return tahlillari — xar xil bosqichlarda, qo'rqitmasdan.
• Statik tahlil usullari: disassembler/decompiler (masalan Ghidra/IDA) ishlatish, kod-oqimi va ma'lumot-oqimi tahlili.
• Dinamik tahlil va xulq-atvorni kuzatish: sandbox/VMda ishga tushirish, jarayon kuzatuv, API chaqiriqlari va I/O kuzatuvi.
• Packer/obfuscation aniqlash va asosiy yondashuvlar.
• Xotira tahlili va runtime izlari: xotira dumplarini tekshirish (kirish darajasi).
• PoC tayyorlash, topilmalarni tasniflash va texnik hisobot yozish.
• Xavfsizlik, axloqiy va huquqiy chegaralar: tahlil muhitini izolyatsiya qilish, xavfsizlik protokollari va responsible disclosure jarayonlari.

Vositalar & resurslar (misollar):
Ghidra / IDA / Radare2 (statik), x64dbg / OllyDbg (dinamik), Binary Ninja (ixtiyoriy), Cuckoo yoki shunga oʻxshash sandbox yechimlari, procmon/strace, Sysinternals vositalari.

Format & metodologiya:
Kurs amaliyotga yoʻnaltirilgan. Har modul: qisqa nazariya → jonli demo → yakka/takim lab mashg'ulotlari aylanishi. Barcha ishlar izolyatsiyalangan laboratoriya muhitida (VM, izolyatsiyalangan tarmoq, snapshot) amalga oshiriladi; haqiqiy namunalar tahlil qilinadi, ammo zararli maqsadlarda foydalanish bo'yicha koʻrsatmalar berilmaydi.

Oʻquv natijalari:

• Binary formatlarini va asosiy assembly tuzilmalarni tushunib sharhlash;
• Statik va dinamik tahlil yordamida namunani xulqini aniqlash va tasniflash;
• Oddiy PoClar va texnik topilmalarni yaratish hamda ularni texnik va rahbarlik auditoriyasiga taqdim etish;
• Xavfsiz tahlil muhitini tashkil etish tamoyillarini (izolyatsiya, snapshot, tarmoq cheklovlari) qoʻllash.

Kimlar uchun:
Malware tahlili yoki tersine muhandislikka kirishni xohlovchi xavfsizlik muhandislari, DFIR/pentest jamoalari, xavfsizlikga qiziqqan dasturchilar va kiber-intelligence mutaxassislari.

Oldingi talablar:
Asosiy dasturlash bilimlari (C/C++ yoki shunga oʻxshash), OS tushunchalari va buyruq qatori tajribasi tavsiya etiladi.

Baholash & chiqim:
Ishtirokchilar kichik tahlil loyihasini topshiradi: namunani xavfsiz muhitda tahlil qilish, kuzatilgan xulqning texnik xulosasi va rahbarlarga mos qisqa hisobot.

Davomiylik & jadval:
Jami 30–50 soat (modullar asosida, 4–6 hafta; dam olish kunlari yoki intensiv variantlar).

Axloq & xavfsizlik majburiyati:
Kursda ishlatiladigan namunalar faqat tahlil va ta'lim maqsadlarida; qatnashchilardan axloqiy qoidalarga rioya qilish, muhitni izolyatsiya qilish va topilmalarni mas'uliyat bilan tarqatish talab etiladi.`,
      duration: "30-50 soat",
      level: "Ilg'or",
      format: "Jonli + Lab",
      icon: "Cog"
    },
    {
      id: 3,
      title: "Amaliy Axloqiy Haker (Uchdan Uchgacha Pentest)",
      description: "Uchdan uchgacha penetratsiya testining barcha bosqichlarini haqiqiy dunyo qoidalari (RoE) bilan tajriba qiling. Jamoa koordinatsiyasi, axloqiy onglik va himoyaga yo'naltirilgan fikrlash ko'nikmalarini egallang.",
      fullDescription: `Bu ta'lim sizga uchdan uchgacha penetratsiya testining barcha bosqichlarini haqiqiy dunyo qoidalari (Rules of Engagement, RoE) bilan amaliy tajriba qilishni va shu bilan birga jamoa ichida koordinatsiya, axloqiy onglik va himoyaga yo'naltirilgan fikrlash ko'nikmalarini berishni maqsad qiladi. Nazariya qisqa va aniq bo'ladi, jonli demolar va jamoa laboratoriyalari bilan mustahkamlanadi va oxirida haqiqiy mini red-team stsenariysi bilan o'rganganlaringizni amaliyotga tatbiq etasiz.

Ta'lim maqsadi:

• Ishtirokchilarga RoE bilan mos uchdan uchgacha pentest jarayonini qo'llash ko'nikmalarini berish
• Jamoa ichidagi vazifa taqsimoti, aloqa va operatsiya koordinatsiyasi qobiliyatlarini rivojlantirish
• Himoyaga yo'naltirilgan nuqtai nazar va axloqiy mas'uliyat ongini shakllantirish

Mavzu sarlavhalari (yuqori daraja):

• RoE va ruxsat jarayonlari: qamrov belgilash, ruxsat mexanizmlari va huquqiy/axloqiy chegaralar
• Kashfiyot (Recon): maqsad belgilash, OSINT va aktivlar inventarini yaratish
• Skanerlash va zaiflik kashfiyoti: aktiv va passiv skanerlash, servis/port kashfiyoti, avtomatik va qo'lda tasdiqlash
• Tasdiqlash va ta'sir tahlili: zaifliklarni xavfsiz tasdiqlash va mumkin bo'lgan ta'sirlarni baholash
• Ekspluatatsiya stsenariylari va simulyatsiya: nazorat ostidagi muhitlarda stsenariy asosida tasdiqlash va muhokama
• Pivoting va lateral harakat (simulyatsiya): kirishning qanday kengayishi mumkinligini aniqlash va ta'sirlarini tahlil qilish
• Hisobot berish: texnik topilmalarni batafsillash va boshqaruv xulosasini tayyorlash
• Mini red-team stsenariysi: jamoa rejalashtirish, amalga oshirish va natijalarni hisobot qilish

Texnik va harakat yo'naltirilgan amaliyotlar:

• Haqiqiy OSINT vazifasi: jamoalar cheklangan vaqt ichida ochiq manba topilmalarini yig'ib ustuvorlashtiradi
• Tarmoq kashfiyot challenge: izolyatsiya qilingan laboratoriyada maqsadli tarmoq xaritasini chiqarish va muhim aktivlarni aniqlash
• AD xaritalash stsenariysi: Active Directory ma'lumotlarini yig'ish va hujum yuzasini modellash (faqat aniqlash/hisobot)
• Pivoting va kirish kengaytirish simulyatsiyasi: lateral kashfiyot va kirish tarqalishini rejalashtirish va hisobot berish
• Qisqa "jonli" mashq: jamoalar tez reja tuzib hujum stsenariyasini amalga oshiradi
• Ijtimoiy muhandislik stol stsenariysi: phishing ongligi va hisobot berish
• Log tahlili va aniqlash testi: SIEM/log namunalarini tekshirish va false-positive'larni ajratish
• Ransomware-simulyatsiya ta'siri: biznes jarayonlariga ta'sirini tahlil qilish va ustuvor aralashuv qadamlari
• Capture-the-flag uslubidagi qisqa vazifalar: ball asosidagi baholash bilan motivatsiyani oshirish

Ta'lim formati va metodologiya:
Qisqa nazariya, jonli demo va jamoa asosidagi laboratoriya amaliyotlari aylanishi bilan davom etadi. Barcha ishlar izolyatsiya qilingan virtual laboratoriyalarda amalga oshiriladi. Mini red-team stsenariysi loyiha asosida; jamoalar reja tuzadi, amalga oshiradi va hisobot beradi.

O'quv natijalari (yutuqlar):

• RoE doirasida pentest jarayonini boshidan oxirigacha rejalashtirish va amalga oshirish
• Kashfiyot, skanerlash va tasdiqlash qadamlarini xavfsiz tarzda qo'llash va topilmalarni ustuvorlash
• Texnik topilmalarni ham texnik jamoalar ham rahbarlar uchun tushunarli hisobotlarga aylantirish
• Jamoa ichidagi rol taqsimoti, koordinatsiya va aloqa ko'nikmalarini rivojlantirish
• Red-team/blue-team dinamikasini tajriba qilish va himoyaga yo'naltirilgan istiqbolni egallash

Kimga mos:
Pentest o'rganmoqchi bo'lganlar, xavfsizlik muhandislari, SOC/IR mutaxassislari, tarmoq va tizim administratorlari, kiber xavfsizlik sohasida martaba maqsad qilgan talabalar va yangi bitiruvchilar.

Oldingi talablar:
Asosiy tarmoq bilimi (TCP/IP), asosiy operatsion tizim bilimi va buyruq qatori tajribasi.

Baholash:
Har bir jamoa kichik pentest loyihasini taqdim etadi: qamrov, kashfiyot topilmalari, tasdiqlangan zaifliklar, ta'sir baholash, texnik hisobot va boshqaruv xulosasi.

Muddat va tartib:
Jami 24–40 soat (modulli; dam olish kunlari bloklari yoki intensivlashtirilgan dastur).

Axloq va xavfsizlik majburiyati:
Ta'lim davomida RoE tamoyillariga to'liq rioya qilish majburiy. Laboratoriya muhitlari izolyatsiya qilingan va faqat ta'lim maqsadlarida ishlatiladi.`,
      duration: "24-40 soat",
      level: "O'rta-Ilg'or",
      format: "Jonli + Lab",
      icon: "Users"
    },
    {
      id: 4,
      title: "Amaliy Kiber Razvedka (OSINT & Threat Hunting)",
      description: "Maqsad profillash, axloqiy ma'lumot yig'ish va topilmalarni MITRE ATT&CK matritsasi orqali ma'nolashtirishni o'rganing. Himoya va razvedka yo'naltirilgan amaliy ko'nikmalar egallang.",
      fullDescription: `Ushbu amaliy ta'limda maqsad profillash, axloqiy ma'lumot yig'ish va olingan topilmalarni MITRE ATT&CK matritsasi orqali ma'nolantirish jarayonlarini o'rganasiz. Nazariya qisqa va maqsadga yo'naltirilgan bo'ladi; jonli demolar, amaliy OSINT vazifalari va threat hunting stsenariylari bilan bilimlar mustahkamlanadi. Ta'lim oxirida ham himoya ham razvedka yo'naltirilgan amaliy ko'nikmalarni egallagan bo'lasiz.

Ta'lim maqsadi:

• Ishtirokchilarga maqsadga yo'naltirilgan profillash va axloqiy ma'lumot yig'ish jarayonlarini amaliy o'rgatish
• Yig'ilgan ma'lumotlarni MITRE ATT&CK doirasida tahlil qilib tahdid aktörlarining TTP'larini aniqlay olish qobiliyatini berish
• SIEM va log manbalari orqali samarali threat hunting amaliyotlarini qo'llay olish va topilmalarni operatsion harakatlarga aylantira olish ko'nikmalarini berish

Mavzu sarlavhalari (yuqori daraja):

• OSINT asoslari: maqsad belgilash, manba tasnifi, ochiq va yopiq vebdan axloqiy ma'lumot yig'ish usullari
• Vositalar va avtomatlashtirish: Maltego, SpiderFoot, Shodan, theHarvester, Google Dorking, OSINT frameworklari va API foydalanish
• Ma'lumot boyitish va tasdiqlash: ko'p manbadan tasdiqlash, PII/false-positive boshqaruvi va ishonchlilik baholash
• Dark web va forum kuzatuvi: axloqiy chegaralar ichida kuzatish va ishlov beriladigan razvedkaga aylantirish
• MITRE ATT&CK bilan moslashtirish: IOC'lar va xulq-atvor naqshlarini ATT&CK texnikalariga xaritalash va tahdid profili chiqarish
• Threat hunting amaliyotlari: gipoteza yaratish, SIEM/so'rov ishlab chiqish, IOC ovi va ov keyingi tahlil
• Tahdid hisobot berish: texnik topilmalarning TI feed, IOC ro'yxatlari, TTP hisobotlari va rahbar xulosasiga aylantirilishi

Texnik va harakat yo'naltirilgan amaliyotlar:

• Maqsad profillash vazifasi: cheklangan vaqt ichida maqsad tashkilot yoki shaxs uchun boy profillash va ustuvorlash
• Shodan va IoT kashfiyot challenge: internetdan kirish mumkin bo'lgan aktivlarni aniqlash va xavf baholash
• Dark web skanerlash stsenariysi: izolyatsiya qilingan muhitda forum/post kuzatuv va olingan ma'lumotni tasniflash
• MITRE mapping ustaxonasi: haqiqiy holat ma'lumotlari ustida ATT&CK moslashtirish va TTP hisoboti yaratish
• SIEM hunting drill: namuna log dataset'i ustida so'rov yozish, gipoteza tasdiqlash va IOC chiqarish
• Threat intelligence enrichment: avtomatik/qo'lda boyitish bilan IOC'larni tasdiqlash va taksonomiyaga joylashtirish
• Capture-the-IOC: qisqa vazifalar bilan muhim IOC'larni aniqlash, baholash va hisobot berish

Ta'lim formati va metodologiya:
Qisqa nazariya, jonli demo va yakka/jamoa vazifalari bilan davom etadi. Amaliyotlar izolyatsiya qilingan tahlil va test muhitlarida (sandbox, VM) amalga oshiriladi. Har modulda haqiqiy dunyo ma'lumotlari bilan ishlash, vosita integratsiyalari va API foydalanish namunalari ko'rsatiladi.

O'quv natijalari (yutuqlar):

• Maqsadga yo'naltirilgan OSINT jarayonini rejalashtirish va qo'llash, yig'ilgan ma'lumotni tasdiqlash va ustuvorlash
• MITRE ATT&CK'ga mos ravishda TTP va IOC tahlillari qilish, tahdid aktöri profili chiqarish
• SIEM/log ma'lumotlari ustida threat hunting amalga oshirish va samarali qidiruv so'rovlari yozish
• Olingan razvedkani operatsion harakatlarga aylantirish va hisobot berish
• Texnik topilmalarni ham operatsion jamoalarga ham rahbariyatga tushunarli tarzda taqdim etish

Kimga mos:
Kiber razvedka, SOC va IR jamoalarida ishlovchilar, xavfsizlik analitiklari va threat hunter'lar, SOC operatorlari va hodisa javob jamoalari, OSINT/CTI sohasida ixtisoslashmoqchi bo'lgan xavfsizlik mutaxassislari.

Oldingi talablar:
Asosiy tarmoq va xavfsizlik bilimi (TCP/IP, asosiy log tushunchalari), buyruq qatori va asosiy skript bilimi (Python/Bash) tavsiya etiladi.

Baholash:
Ishtirokchilar jamoa yoki yakka tartibda qisqa OSINT/profil vazifalarini bajaradilar va olingan IOC'lar, boyitish hisoboti va MITRE moslashtirish taqdim etadilar.

Muddat va tartib:
Jami 18–30 soat oralig'ida modulli tuzilma (masalan, 3 dam olish kuni yoki 5 kechki sessiya).

Axloq va xavfsizlik majburiyati:
Barcha ma'lumot yig'ish faoliyatlari axloqiy va huquqiy doirada, ruxsat bilan va mas'uliyat bilan amalga oshiriladi. Yig'ilgan maxfiy ma'lumotlarni himoya qilish, PII boshqaruvi va mas'uliyatli oshkor qilish jarayonlariga rioya qilish majburiy.`,
      duration: "18-30 soat",
      level: "O'rta",
      format: "Jonli + Lab",
      icon: "Search"
    },
    {
      id: 5,
      title: "Linux va Windows Mustahkamlash (Hujumchidek Oʻyla, Himoyani Toʻgʻri Qur)",
      description: "Hujumchi nigohidan zaifliklarni aniqlang va tizimlarni bosqichma-bosqich mustahkamlang. Haqiqiy hujum stsenariyslarini tushunib, himoyani toʻgʻri quring.",
      fullDescription: `Ushbu amaliy kurs ishtirokchilarga ham Linux ham Windows operatsion tizimlarida hujumchi nigohidan zaifliklarni aniqlashni va keyin bu tizimlarni bosqichma-bosqich "mustahkamlashni" o'rgatadi. Nazariya qisqa bo'ladi; asosiy diqqat haqiqiy hujum stsenariyslarini tushunish va ularga qarshi himoyani to'g'ri o'rnatishga qaratilgan. Ishtirokchilar hujumchi tizim ichida qanday harakat qilishini ko'radi, keyin xuddi shu tizimni professional xavfsizlik muhandisi kabi himoya qilishni o'rganadi.

Kurs maqsadi:

• Linux va Windows muhitlarida hujum sirtlarini aniqlash va kamaytirish ko'nikmalarini berish
• Xavfsizlik zaifliklarini proaktiv aniqlash va himoyani kuchaytirish
• Haqiqiy hujum texnikalarini tanish va samarali mustahkamlash siyosatlarini ishlab chiqish
• "Hujumchidek o'yla, xavfsizlikchi kabi himoya qil" yondashuvini shakllantirish

Mavzu sarlavhalari:

• Mustahkamlash asosiy tamoyillari
• Linux xavfsizligi: fayl ruxsatlari, sudo sozlash, SSH xavfsizligi, log tahlili
• Windows xavfsizligi: Active Directory, GPO, foydalanuvchi ruxsatlari, PowerShell xavfsizligi
• Xizmat asosida mustahkamlash: Apache/IIS, MySQL/MSSQL, RDP/SSH sozlamalari
• Zaif konfiguratsiyani aniqlash va bartaraf etish
• Imtiyozlarni oshirish va doimiylikka qarshi choralar
• Firewall, tarmoq segmentatsiyasi va minimal ruxsat tamoyili
• Hodisalarni aniqlash, log kuzatuv va audit vositalari
• CIS Benchmark va STIG mos siyosatlarini yaratish

Texnik amaliyotlar:

• Zaif virtual mashinada hujum simulyatsiyasi va himoya sozlamalari
• SSH brute-force aniqlash va kirish cheklash
• PowerShell log tahlili
• Mahalliy imtiyozlarni oshirish vektorlarini yopish
• Linux log tahlili orqali ruxsatsiz kirishni aniqlash
• CIS Benchmark testi va hisobot baholash
• Red-Team va Blue-Team mini senariysi

Kurs formati:
Nazariya + jonli demo + laboratoriya mashg'ulotlari. Ishtirokchilar o'z virtual mashinalarida ishlaydi. Haqiqiy hujum namunalari xavfsiz laboratoriya muhitida ko'rsatiladi.

Yutuqlar:

• Linux va Windows'da zaifliklarni aniqlash va yopish
• Xalqaro standartlar bo'yicha tizim mustahkamlashni qo'llash
• Log tahlili va hujumlarni kuzatish jarayonlarini boshqarish
• Korporativ xavfsizlik nazorat ro'yxatini yaratish

Kimlar uchun:
Tizim administratorlari, kiberxavfsizlik muhandislari, SOC/IR jamoalari, pentester va Blue/Red-Team ishtirokchilari.

Davomiylik:
20–30 soat (4 kun intensiv yoki 6 kechki modul).

Etika va xavfsizlik:
Barcha simulyatsiyalar izolyatsiya qilingan muhitda amalga oshiriladi. Haqiqiy tizimlarga aralashish taqiqlangan. Kurs faqat himoya va xabardorlik maqsadida.`,
      duration: "20-30 soat",
      level: "O'rta",
      format: "Jonli + Lab",
      icon: "Shield"
    },
    {
      id: 6,
      title: "Amaliy Mobil Xavfsizlik (Android & iOS)",
      description: "Android va iOS ilovalarining ichki tuzilishini kashf eting, hujumchi texnikalarini o'rganing va ilovalarni xavfsiz holatga keltiring. Mobil pentest va xavfsiz kod ishlab chiqish ko'nikmalarini birlashtiring.",
      fullDescription: `Ushbu amaliy ta'lim ishtirokchilarga mobil ilovalarda xavfsizlik testlarini qanday o'tkazishni, zaifliklarni qanday aniqlash va bartaraf etishni hamda xavfsiz ilova ishlab chiqish tamoyillarini o'rgatadi. Ishtirokchilar hujumchi nuqtai nazaridan mobil ilovalarni qanday tahlil qilishni o'rganadilar, shu bilan birga himoyaga yo'naltirilgan ishlab chiqish va xavfsiz konfiguratsiya texnikalarini ham tajriba qiladilar. Ta'lim davomida haqiqiy APK va IPA fayllari ustida tahlil, teskari muhandislik, ma'lumot manipulyatsiyasi va xavfsiz kodlash stsenariylari qo'llaniladi.

Ta'lim maqsadi:

• Android va iOS muhitlarida mobil ilova penetratsiya testini o'tkaza olish ko'nikmalarini berish
• Ma'lumot xavfsizligi, identifikatsiya, avtorizatsiya va shifrlash xatolarini tanish
• OWASP Mobile Top 10 doirasida zaifliklarni tahlil qilib yopish
• Xavfsiz mobil kodlash va mustahkamlash tamoyillarini o'rgatish
• Hujumchi va himoyachi nuqtai nazarlarini birlashtirish

Mavzu sarlavhalari:

• Mobil xavfsizlik asoslari va tahdid modeli
• OWASP Mobile Top 10 qo'llanmalari
• Android xavfsizligi: APK tahlili, Smali, SSL pinning, WebView, root aniqlash
• iOS xavfsizligi: IPA tekshirish, Keychain, jailbreak aniqlash, sandbox, xavfsiz saqlash
• Tarmoq xavfsizligi: HTTPS, MITM, proksi tahlili, Burp Suite, Frida, Objection
• Xavfsiz kodlash: kirish ma'lumotlarini tekshirish, ma'lumot shifrlash, token boshqaruvi
• Mobil mustahkamlash: imzolash, obfuskatsiya, MDM siyosatlari

Texnik qo'llanmalar:

• Haqiqiy APK va IPA fayllari ustida test
• Decompile va teskari muhandislik (APKTool, JADX, Hopper)
• SSL Pinning bypass, root va jailbreak aniqlash testlari
• Burp Suite va Frida bilan trafik manipulyatsiyasi
• Credential capture va tuzatish mashqlari
• Mobil API xavfsizlik testlari
• Xavfsiz kodlash qo'llanmalari va Blue-Team stsenariysi

Ta'lim formati:
Nazariya, jonli demo va laboratoriya mashqlari. Ishtirokchilarga virtual laboratoriya va emulyator muhiti taqdim etiladi. Haqiqiy mobil ilovalar bilan "test – tuzatish – qayta test" aylanishi qo'llaniladi.

Yutuqlar:

• Mobil ilovalarda xavfsizlik testlarini o'tkaza olish
• OWASP Mobile Top 10 zaifliklarini aniqlash va tasdiqlash
• SSL Pinning, Root/Jailbreak Detection jarayonlarini tushunish
• Xavfsiz kodlash tamoyillarini qo'llash
• API va tarmoq xavfsizligi nazoratlarini o'rnatish
• Ilova mustahkamlash usullarini ishlatish

Kimga mos:
Mobil ishlab chiquvchilar, xavfsizlik test mutaxassislari, SOC va IR jamoalari, mobil xavfsizlikka yo'nalmoqchi dasturchilar, kiberxavfsizlik talabalari va yangi bitiruvchilar.

Oldingi talablar:
Asosiy tarmoq bilimi (TCP/IP, HTTPS), Android Studio yoki shunga o'xshash muhit bilimi, buyruq qatori tajribasi.

Baholash:
Ishtirokchilar zaif mobil ilovani tahlil qilib xavfsiz holatga keltiradi. Yakuniy hisobot tayyorlanadi: zaifliklar, yechimlar, xulosalar.

Muddat:
20–35 soat (4 kun intensiv yoki 6 kechki modul).

Axloq va xavfsizlik:
Barcha ishlar izolyatsiya qilingan muhitlarda amalga oshiriladi. Haqiqiy ilovalarga aralashish taqiqlangan. Ta'lim faqat himoya va xabardorlik maqsadida.`,
      duration: "20-35 soat",
      level: "O'rta-Ilg'or",
      format: "Jonli + Lab",
      icon: "Smartphone"
    }
  ],
  ru: [
    {
      id: 1,
      title: "Практическая веб-безопасность (Взгляд хакера)",
      description: "Рассматривайте веб-приложения с точки зрения security-researcher / этичного хакера. Изучите темы OWASP Top-10 на реальных кейсах.",
      fullDescription: `На этом практическом курсе мы рассматриваем веб-приложения с точки зрения security-researcher / этичного хакера. Участники изучат темы OWASP Top-10 на реальных кейсах — как уязвимости эксплуатируются и как их необходимо исправлять. Теория даётся кратко и сразу подкрепляется живыми демо и практическими лабораторными заданиями.

Темы и методики:

• Захват трафика в Burp Suite, прокси-потоки и repeater-упражнения.
• Поиск проблем авторизации и управления сессиями (IDOR, broken auth).
• Обнаружение логических ошибок в бизнес-процессах и сценариев эксплуатации.
• Поиск, валидация и разработка PoC для критичных уязвимостей: SQLi, XSS, SSRF.
• Лаборатории в стиле bug-bounty для практики и подготовки отчётов.
• Преобразование технических находок в управленческие сводки и планы исправлений.

Структура курса:
Каждый модуль: короткая теория → live-демо → практическая лабораторная работа (индивидуально/в команде). По завершении курса каждый участник предоставляет минимум один PoC и короткий технический отчёт; инструкторы дают практическую обратную связь.

Результаты обучения:

• Практическое обнаружение и валидация уязвимостей OWASP Top-10.
• Создание воспроизводимых PoC и эффективных технических отчётов.
• Анализ цепочек атак и предложение приоритетных мер исправления.

Кому подходит / Предварительные требования:
Веб-разработчикам, инженерам по безопасности, начинающим пентестерам и участникам bug-bounty. Рекомендуются базовые знания HTTP, HTML и SQL.

Формат и длительность:
Live-сессии + доступ в лабораторию. Оценка: PoC + короткий технический отчёт. Длительность: 30–45 часов (модульно; формат — выходные или интенсив).`,
      duration: "30-45 часов",
      level: "Средний-Продвинутый",
      format: "Live + Lab",
      icon: "Globe"
    },
    {
      id: 2,
      title: "Практическая реверс-инженерия (RE & Malware)",
      description: "Изучите основное мышление и методы реверс-инжиниринга и анализа вредоносного ПО. Научитесь исследовать внутреннюю структуру бинарных файлов и делать ассемблер читабельным.",
      fullDescription: `Этот практический курс направлен на обучение участников основному мышлению и методам реверс-инжиниринга и анализа вредоносного ПО. Курс использует подход «понимать поведение вместо написания кода»: вы научитесь исследовать внутреннюю структуру бинарных файлов, делать ассемблер читабельным и анализировать влияние образца на систему в контролируемой среде. Пример вредоносного ПО будет проанализирован полностью — от начала до конца.

Что вы изучите (темы):

• Основы реверс-инжиниринга: форматы PE/ELF, точки входа, зависимости и базовые структуры бинарных файлов.
• Практика чтения ассемблера (x86/x86_64): понимание логики, границ функций, анализ вызовов/возвратов — пошагово и без запугивания.
• Методы статического анализа: использование дизассемблеров/декомпиляторов (например Ghidra/IDA), анализ потока кода и потока данных.
• Динамический анализ и исследование поведения: запуск в песочнице/VM, мониторинг процессов, вызовы API и наблюдение I/O.
• Обнаружение packer/obfuscation и базовые подходы.
• Анализ памяти и runtime-артефактов: изучение дампов памяти (базовый уровень).
• Подготовка PoC, классификация находок и техническая отчетность.
• Безопасность, этика и правовые рамки: изоляция среды анализа, протоколы безопасности и процедуры responsible disclosure.

Инструменты & ресурсы (примеры):
Ghidra / IDA / Radare2 (статический анализ), x64dbg / OllyDbg (динамический анализ), Binary Ninja (опционально), Cuckoo или аналогичные решения для песочниц, procmon/strace, инструменты Sysinternals.

Формат & методология:
Курс ориентирован на практику. Каждый модуль: краткая теория → живое демо → индивидуальные/командные лабораторные работы. Все работы проводятся в изолированной лабораторной среде (виртуальные машины, изолированные сети, снимки); реальные образцы анализируются, но инструкции по их злонамеренному использованию не предоставляются.

Результаты обучения:

• Понимать и интерпретировать форматы бинарных файлов и базовые конструкции ассемблера;
• С помощью статического и динамического анализа выявлять и классифицировать поведение образца;
• Создавать простые PoC и технические находки и представлять их технической и управленческой аудитории;
• Применять принципы построения безопасной среды анализа (изоляция, снимки, сетевые ограничения).

Кому подходит:
Инженерам по безопасности, командам DFIR/pentest, разработчикам, интересующимся безопасностью, и специалистам киберразведки, желающим начать в анализе malware или реверс-инжиниринге.

Требования:
Рекомендуются базовые навыки программирования (C/C++ или аналогичные), базовое понимание ОС и опыт работы с командной строкой.

Оценка & итог:
Участники выполняют небольшой аналитический проект: образец анализируется в безопасной среде, готовится техническое резюме наблюдаемого поведения и краткий отчёт для руководства.

Продолжительность & расписание:
Всего 30–50 часов (модульно, 4–6 недель; варианты по выходным или в интенсивном формате).

Этика & безопасность:
Образцы используются только в целях анализа и обучения; от участников требуется соблюдение этических норм, изоляция среды и ответственное распространение результатов.`,
      duration: "30-50 часов",
      level: "Продвинутый",
      format: "Live + Lab",
      icon: "Cog"
    },
    {
      id: 3,
      title: "Практический Этичный Хакер (Сквозной Пентест)",
      description: "Получите практический опыт всех этапов сквозного penetration-test в рамках реальных правил (RoE). Развейте командную работу, этическую осознанность и защитно-ориентированное мышление.",
      fullDescription: `Курс направлен на то, чтобы дать вам практический опыт проведения полного penetration-test в рамках реальных правил (Rules of Engagement, RoE), а также развить командную работу, этическую осознанность и ориентированное на защиту мышление. Теория даётся кратко и по делу, подкрепляется живыми демонстрациями и командными лабораториями, а в конце вы примените полученные знания в реалистичном мини-red-team сценарии.

Цель обучения:

• Научить участников выполнять end-to-end pentest в соответствии с RoE
• Повысить навыки распределения ролей в команде, коммуникации и координации операций
• Сформировать защитно-ориентированный подход и чувство этической ответственности

Ключевые темы (высокий уровень):

• RoE и процессы авторизации: определение объёма, механизмы разрешений, правовые и этические границы
• Разведка (Recon): выбор целей, OSINT и составление инвентаря активов
• Сканирование и обнаружение уязвимостей: активное/пассивное сканирование, перечисление сервисов/портов, автоматическая и ручная проверка
• Верификация и анализ воздействия: безопасная проверка уязвимостей и оценка возможных последствий
• Сценарии эксплойтов и симуляции: валидация по сценариям и обсуждение в контролируемой среде
• Пивотинг и латеральное перемещение (симуляция): определение путей расширения доступа и анализ их воздействия
• Отчётность: документирование технических находок и подготовка executive summary
• Мини-red-team сценарий: планирование команды, выполнение и отчётность

Технические и практико-ориентированные упражнения:

• Реалистичная OSINT-задача: команды в ограниченное время собирают и приоритизируют открытые источники
• Задача по сетевой разведке: картирование целевой сети и выявление критических активов
• Сценарий картирования AD: моделирование поверхности атаки с помощью сбора данных Active Directory
• Симуляция пивотинга и эскалации: планирование латерального поиска и расширения доступа
• Короткая «live» тренировка: команды быстро планируют и выполняют атакующую операцию
• Симуляция социальной инженерии: упражнение по повышению осведомлённости о фишинге
• Анализ логов и тестирование детекций: изучение SIEM/log, фильтрация false-positive
• Оценка воздействия ransomware-симуляции: анализ влияния на бизнес и определение шагов реагирования
• Capture-the-flag задания: система начисления очков для мотивации

Формат и методика:
Краткая теория, live-демо и циклы командных лабораторий. Все работы выполняются в изолированных виртуальных лабораториях. Мини-red-team как проект: команды планируют, выполняют и отчитываются.

Результаты обучения:

• Планировать, проводить и отчётно оформлять pentest в рамках RoE
• Проводить разведку, сканирование и верификацию безопасно, приоритизировать находки
• Преобразовывать технические находки в понятные отчёты
• Улучшать коммуникацию в команде, распределение ролей и координацию
• Практически прочувствовать динамику red-team/blue-team и развить защитно-ориентированное мышление

Кому подходит:
Желающим изучать pentest, инженерам по безопасности, специалистам SOC/IR, администраторам сетей и систем, студентам и выпускникам.

Предварительные требования:
Базовые знания сетей (TCP/IP), базовые знания ОС и опыт работы в командной строке.

Оценка:
Каждая команда представляет pentest-проект: объём, результаты разведки, подтверждённые уязвимости, оценка воздействия, технический отчёт и executive summary.

Длительность и расписание:
Всего 24–40 часов (модульная подача; блоки по выходным или интенсивные форматы).

Этика и безопасность:
Полное соблюдение RoE обязательно. Лаборатории работают на изолированной виртуальной инфраструктуре и используются только в образовательных целях.

Цели обучения:

• Дать участникам навыки применения сквозного процесса пентеста в соответствии с RoE
• Развить компетенции внутрикомандного распределения задач, коммуникации и операционной координации
• Сформировать защитно-ориентированную перспективу и этическое сознание ответственности

Темы курса (высокий уровень):

• RoE и процессы разрешений: определение области, механизмы разрешений и правовые/этические границы
• Разведка (Recon): определение целей, OSINT и создание инвентаря активов
• Сканирование и обнаружение уязвимостей: активное и пассивное сканирование, обнаружение сервисов/портов, автоматическая и ручная валидация
• Валидация и анализ воздействия: безопасная валидация уязвимостей и оценка возможных последствий
• Сценарии эксплуатации и симуляция: валидация на основе сценариев в контролируемых средах и обсуждение
• Pivoting и латеральное движение (симуляция): определение возможностей расширения доступа и анализ воздействий
• Отчетность: детализация технических находок и подготовка управленческих сводок
• Мини red-team сценарий: командное планирование, выполнение и отчетность по результатам

Технические и действие-ориентированные практики:

• Реалистичная OSINT задача: команды собирают и приоритизируют находки из открытых источников в ограниченное время
• Сетевая разведка challenge: составление карты целевой сети и выявление критических активов в изолированной лаборатории
• AD картирование сценарий: сбор информации Active Directory и моделирование поверхности атаки (только обнаружение/отчетность)
• Pivoting и симуляция расширения доступа: планирование и отчетность латеральной разведки и распространения доступа
• Короткие "живые" учения: команды быстро планируют и выполняют сценарий атаки
• Настольный сценарий социальной инженерии: осведомленность о фишинге и отчетность
• Анализ логов и тест обнаружения: изучение примеров SIEM/логов и разделение false-positive
• Воздействие ransomware-симуляции: анализ влияния на бизнес-процессы и приоритетные шаги реагирования
• Короткие задачи в стиле Capture-the-flag: повышение мотивации через балльную оценку

Формат и методология обучения:
Прогрессирует через циклы краткой теории, живых демо и командных лабораторных практик. Все работы выполняются в изолированных виртуальных лабораториях. Мини red-team сценарий основан на проектах; команды планируют, выполняют и представляют отчеты.

Результаты обучения (достижения):

• Планирование и выполнение процесса пентеста от начала до конца в рамках RoE
• Безопасное применение шагов разведки, сканирования и валидации с приоритизацией находок
• Преобразование технических находок в понятные отчеты как для технических команд, так и для руководителей
• Развитие навыков внутрикомандного распределения ролей, координации и коммуникации
• Получение опыта red-team/blue-team динамики и защитно-ориентированной перспективы

Кому подходит:
Желающие изучить пентест, инженеры безопасности, специалисты SOC/IR, сетевые и системные администраторы, студенты и новые выпускники, нацеленные на карьеру в кибербезопасности.

Предварительные требования:
Базовые знания сетей (TCP/IP), базовые знания операционных систем и опыт командной строки.

Оценка:
Каждая команда представит небольшой проект пентеста: область, находки разведки, валидированные уязвимости, оценка воздействия, технический отчет и управленческая сводка.

Продолжительность и расписание:
Всего 24–40 часов (модульно; блоки выходных или интенсивная программа).

Этические обязательства и безопасность:
Полное соблюдение принципов RoE обязательно на протяжении всего обучения. Лабораторные среды изолированы и используются только в образовательных целях.`,
      duration: "24-40 часов",
      level: "Средний-Продвинутый",
      format: "Live + Lab",
      icon: "Users"
    },
    {
      id: 4,
      title: "Практическая Киберразведка (OSINT & Threat Hunting)",
      description: "Изучите профилирование целей, этичный сбор данных и сопоставление результатов с матрицей MITRE ATT&CK. Приобретите практические навыки в защитных и разведывательных процессах.",
      fullDescription: `На практическом курсе вы изучите профилирование целей, этичный сбор данных из открытых и закрытых источников и методику сопоставления полученных данных с матрицей MITRE ATT&CK. Теория даётся кратко и по делу, материал закрепляется живыми демонстрациями, практическими OSINT-заданиями и сценариями threat hunting. По окончании курса вы приобретёте практические навыки как в оборонительных, так и в разведывательных процессах.

Цель курса:

• Научить участников профайлингу целей и этичному сбору данных
• Обеспечить возможность анализа собранных данных через MITRE ATT&CK для определения TTP угроз
• Развить навыки threat hunting по данным SIEM и логов и перевод находок в оперативные меры

Основные темы:

• Основы OSINT: определение целей, классификация источников, методы этичного сбора данных из открытых и закрытых веб-источников
• Инструменты и автоматизация: Maltego, SpiderFoot, Shodan, theHarvester, Google Dorking, OSINT-фреймворки и API
• Обогащение и верификация данных: перекрёстная проверка источников, управление PII/false-positive и оценка достоверности
• Мониторинг дарквеба и форумов: легальный мониторинг и преобразование сигналов в пригодную к использованию разведку
• Сопоставление с MITRE ATT&CK: привязка IOC и паттернов поведения к техникам ATT&CK и формирование профиля угрозы
• Практики threat hunting: формирование гипотез, написание запросов для SIEM, охота за IOC и пост-хант анализ
• Отчётность по угрозам: конвертация технических находок в TI-фиды, списки IOC, отчёты по TTP и executive summary

Технические и практико-ориентированные упражнения:

• Задача по профайлингу цели: команды за ограниченное время собирают и приоритизируют расширенные профили цели
• Shodan & IoT challenge: быстрое обнаружение публично доступных активов и оценка риска
• Сценарий мониторинга дарквеба: отслеживание постов/форумов в изолированной среде и классификация полученных данных
• Мастерская по MITRE mapping: сопоставление реального кейса с ATT&CK и составление TTP-отчёта
• SIEM hunting drill: написание запросов по образцам логов, проверка гипотез и извлечение IOC
• Enrichment: автоматическое и ручное обогащение IOC и их классификация по таксономии
• Capture-the-IOC: короткие задания на выявление критических IOC с оценкой и отчётом

Формат и методология:
Краткая теория, живые демонстрации и практические индивидуальные/командные задания. Практические занятия проводятся в изолированных средах анализа/тестирования (sandbox, VM). Демонстрируются реальные данные, интеграции инструментов и примеры работы с API.

Результаты обучения:

• Планировать и выполнять ориентированные на цель OSINT-процессы, верифицировать и приоритизировать собранные данные
• Выполнять анализ TTP и IOC с привязкой к MITRE ATT&CK и формировать профиль угрозы
• Проводить threat hunting по данным SIEM/log и создавать эффективные поисковые запросы
• Переводить собранную разведку в оперативные действия (оповещения, правила блокировки, IOC-фиды)
• Чётко представлять технические находки оперативным командам и руководству

Кому подходит:
Практики CTI/OSINT, сотрудники SOC и IR, аналитики безопасности и threat hunter'ы, операторы SOC и команды реагирования на инциденты, профессионалы, желающие специализироваться в OSINT/CTI.

Требования:
Базовые знания сетей (TCP/IP) и базовые понятия логов, навыки работы с командной строкой и базовый скриптинг (Python/Bash) приветствуются.

Оценка:
Участники выполняют короткие OSINT/профайлинг задания и представляют IOC, отчёты по обогащению и MITRE-маппинг.

Продолжительность:
Всего 18–30 часов, модульная подача (например, 3 сессии по выходным или 5 вечерних сессий).

Этика & безопасность:
Все мероприятия по сбору данных проводятся этично, в рамках закона и с необходимыми разрешениями. Защита собранных чувствительных данных, управление PII и процессы ответственного раскрытия обязательны.`,
      duration: "18-30 часов",
      level: "Средний",
      format: "Live + Lab",
      icon: "Search"
    },
    {
      id: 5,
      title: "Усиление Linux & Windows (Думай Как Атакующий, Защищай Как Профессионал)",
      description: "Выявляйте уязвимости глазами атакующего и пошагово усиливайте системы. Понимайте реальные сценарии атак и правильно строите защиту.",
      fullDescription: `Практический курс обучает выявлению уязвимостей в системах Linux и Windows с точки зрения атакующего и их пошаговому устранению. Теория краткая, основной упор делается на понимание реальных атак и правильное построение защиты. Участники увидят, как действует атакующий, и научатся защищать систему как инженер по безопасности.

Цели курса:

• Определять и снижать поверхность атаки в средах Linux и Windows
• Проактивно обнаруживать и устранять уязвимости
• Понимать реальные векторы атак и разрабатывать эффективные политики усиления
• Формировать подход «думай как атакующий, защищай как специалист»

Темы курса:

• Основы hardening
• Безопасность Linux: права файлов, sudo, SSH, анализ логов
• Безопасность Windows: Active Directory, GPO, авторизация пользователей, безопасность PowerShell
• Усиление на уровне сервисов: Apache/IIS, MySQL/MSSQL, конфигурация RDP/SSH
• Выявление и устранение слабых конфигураций
• Предотвращение повышения привилегий и постоянства
• Firewall, сегментация сети и принцип минимальных привилегий
• Обнаружение событий, мониторинг логов и инструменты аудита
• Создание политик, соответствующих CIS Benchmark и STIG

Технические упражнения:

• Симуляция атаки на уязвимую виртуальную машину и настройка защиты
• Обнаружение SSH brute-force и ограничение доступа
• Анализ логов PowerShell
• Закрытие векторов повышения локальных привилегий
• Обнаружение несанкционированного доступа через анализ логов Linux
• Тестирование и оценка по CIS Benchmark
• Мини-сценарий Red-Team против Blue-Team

Формат курса:
Теория + живые демонстрации + лабораторные упражнения. Участники работают на собственных виртуальных машинах. Примеры реальных атак демонстрируются в безопасной лабораторной среде.

Результаты обучения:

• Обнаруживать и устранять уязвимости в Linux и Windows
• Применять усиление системы согласно международным стандартам
• Управлять процессами анализа логов и мониторинга атак
• Создавать корпоративные контрольные списки безопасности

Кому подходит:
Системные администраторы, инженеры по кибербезопасности, команды SOC/IR, pentester'ы и участники Blue/Red Team.

Продолжительность:
20–30 часов (4 интенсивных дня или 6 вечерних модулей).

Этика и безопасность:
Все симуляции проводятся в изолированных средах. Вмешательство в реальные системы запрещено. Обучение проводится исключительно для целей защиты и повышения осведомлённости.`,
      duration: "20-30 часов",
      level: "Средний",
      format: "Live + Lab",
      icon: "Shield"
    },
    {
      id: 6,
      title: "Практическая Мобильная Безопасность (Android & iOS)",
      description: "Исследуйте внутреннюю структуру Android и iOS приложений, изучите техники атакующих и сделайте приложения безопасными. Объедините навыки мобильного пентеста и безопасной разработки.",
      fullDescription: `Этот практический курс обучает участников проведению тестов безопасности мобильных приложений, выявлению и устранению уязвимостей, а также принципам безопасной разработки приложений. Участники изучат анализ мобильных приложений с точки зрения атакующего, а также получат опыт в защитно-ориентированной разработке и безопасной конфигурации. В ходе обучения проводится анализ, реверс-инжиниринг, манипуляция данными и сценарии безопасного кодирования на реальных APK и IPA файлах.

Цели обучения:

• Развить навыки проведения пентестов мобильных приложений в средах Android и iOS
• Научиться выявлять ошибки безопасности данных, аутентификации, авторизации и шифрования
• Анализировать и устранять уязвимости в рамках OWASP Mobile Top 10
• Изучить принципы безопасного мобильного кодирования и усиления защиты
• Объединить подходы атакующего и защитника

Темы курса:

• Основы мобильной безопасности и модель угроз
• Применение OWASP Mobile Top 10
• Безопасность Android: анализ APK, Smali, SSL pinning, WebView, обнаружение root
• Безопасность iOS: исследование IPA, Keychain, обнаружение jailbreak, sandbox, безопасное хранение
• Сетевая безопасность: HTTPS, MITM, анализ прокси, Burp Suite, Frida, Objection
• Безопасное кодирование: валидация ввода, шифрование данных, управление токенами
• Усиление мобильных приложений: подписывание, обфускация, политики MDM

Технические применения:

• Тестирование на реальных APK и IPA файлах
• Декомпиляция и реверс-инжиниринг (APKTool, JADX, Hopper)
• Тесты обхода SSL Pinning, обнаружения root и jailbreak
• Манипуляция трафика с Burp Suite и Frida
• Упражнения по захвату учетных данных и их исправлению
• Тесты безопасности мобильных API
• Применение безопасного кодирования и сценарии Blue-Team

Формат обучения:
Теория, живые демонстрации и лабораторные упражнения. Участникам предоставляется виртуальная лаборатория и среда эмулятора. Применяется цикл "тест – исправление – повторный тест" с реальными мобильными приложениями.

Достижения:

• Проведение тестов безопасности мобильных приложений
• Выявление и подтверждение уязвимостей OWASP Mobile Top 10
• Понимание процессов SSL Pinning, Root/Jailbreak Detection
• Применение принципов безопасного кодирования
• Настройка контролей безопасности API и сети
• Использование методов усиления приложений

Кому подходит:
Мобильные разработчики, специалисты по тестированию безопасности, команды SOC и IR, программисты, желающие перейти в мобильную безопасность, студенты и выпускники в области кибербезопасности.

Предварительные требования:
Базовые знания сетей (TCP/IP, HTTPS), знание Android Studio или аналогичной среды, опыт работы с командной строкой.

Оценка:
Участники анализируют уязвимое мобильное приложение и делают его безопасным. Готовится итоговый отчет: уязвимости, решения, выводы.

Продолжительность:
20–35 часов (4 интенсивных дня или 6 вечерних модулей).

Этика и безопасность:
Все работы проводятся в изолированных средах. Вмешательство в реальные приложения запрещено. Обучение проводится исключительно для целей защиты и повышения осведомленности.`,
      duration: "20-35 часов",
      level: "Средний-Продвинутый",
      format: "Live + Lab",
      icon: "Smartphone"
    }
  ],
  en: [
    {
      id: 1,
      title: "Practical Web Security (Attacker's View)",
      description: "Examine web applications from the perspective of a security researcher / ethical hacker. Learn OWASP Top-10 topics through real-world case studies.",
      fullDescription: `In this hands-on course we examine web applications from the perspective of a security researcher / ethical hacker. Participants will learn OWASP Top-10 topics through real-world case studies, seeing both how vulnerabilities are exploited and how they should be remediated. Theory is kept short and focused, immediately reinforced with live demos and practical labs.

Topics & Methods:

• Burp Suite traffic capture, proxy workflows and repeater exercises.
• Discovery of authorization and session management issues (IDOR, broken auth).
• Identification of business-logic flaws and exploit scenarios.
• Discovery, validation and PoC development for critical issues such as SQLi, XSS, SSRF.
• Bug-bounty style sandbox labs for hands-on practice and reporting.
• Turning technical findings into executive summaries and actionable remediation plans.

Course Flow:
Each module follows: short theory → live demo → individual/team lab practice. By course end every participant delivers at least one PoC and a short technical report; instructors provide practical feedback.

Learning Outcomes:

• Practically detect and validate OWASP Top-10 vulnerabilities.
• Produce repeatable PoCs and effective technical reports.
• Analyse attack chains and propose prioritized remediation steps.

Who & Prerequisites:
Web developers, security engineers, aspiring pentesters and bug-bounty participants. Basic knowledge of HTTP, HTML and SQL is recommended.

Format & Duration:
Live sessions + lab access. Assessment: PoC + short technical report. Duration: 30–45 hours (modular; weekend or intensive formats available).`,
      duration: "30-45 hours",
      level: "Intermediate-Advanced",
      format: "Live + Lab",
      icon: "Globe"
    },
    {
      id: 2,
      title: "Practical Reverse Engineering (RE & Malware)",
      description: "Learn the core mindset and methods of reverse engineering and malware analysis. You will learn to inspect binary internals and make assembly readable.",
      fullDescription: `This hands-on course aims to teach participants the core mindset and methods of reverse engineering and malware analysis. The course adopts a "understand behavior rather than write code" approach: you will learn to inspect binary internals, make assembly readable, and analyze a sample's effects on a system in a controlled environment. A real malware sample will be analyzed end-to-end.

What you will learn (topics):

• Fundamentals of reverse engineering: PE/ELF formats, entry points, dependencies and basic binary structures.
• Assembly reading practices (x86/x86_64): reasoning about logic, function boundaries, call/return analysis — step-by-step, without intimidation.
• Static analysis techniques: using disassemblers/decompilers (e.g., Ghidra/IDA), code-flow and data-flow analysis.
• Dynamic analysis and behavior inspection: sandbox/VM execution, process monitoring, API calls and I/O observation.
• Packer/obfuscation detection and basic approaches.
• Memory analysis and runtime traces: examining memory dumps (introductory level).
• PoC development, findings classification and technical reporting.
• Security, ethics and legal boundaries: isolation of analysis environments, security protocols and responsible disclosure processes.

Tools & resources (examples):
Ghidra / IDA / Radare2 (static), x64dbg / OllyDbg (dynamic), Binary Ninja (optional), Cuckoo or similar sandbox solutions, procmon/strace, Sysinternals tools.

Format & methodology:
The course is practice-focused. Each module follows short theory → live demo → individual/team lab cycle. All work is performed in isolated lab environments (VMs, isolated networks, snapshots); real samples are analyzed, but no instructions are provided for malicious use.

Learning outcomes:

• Understand and interpret binary formats and basic assembly constructs;
• Use static and dynamic analysis to identify and classify a sample's behaviour;
• Produce basic PoCs and technical findings, and report them to both technical and management audiences;
• Apply secure analysis environment principles (isolation, snapshots, network restrictions).

Who should attend:
Security engineers entering malware analysis or reverse engineering, DFIR/pentest teams, security-minded developers and cyber-intelligence professionals.

Prerequisites:
Basic programming knowledge (C/C++ or similar), foundational OS concepts and command-line experience recommended.

Assessment & deliverable:
Participants submit a small analysis project: a sample analyzed in a safe environment, a technical summary of observed behaviour, and an executive-friendly short report.

Duration & schedule:
Total 30–50 hours (modular, 4–6 weeks; weekend or intensive options).

Ethics & safety commitment:
Samples used are for analysis and training only; participants are expected to follow ethical rules, maintain isolated environments, and share findings responsibly.`,
      duration: "30-50 hours",
      level: "Advanced",
      format: "Live + Lab",
      icon: "Cog"
    },
    {
      id: 3,
      title: "Practical Ethical Hacker (End-to-End Pentest)",
      description: "Experience all phases of end-to-end penetration testing under real-world rules (RoE). Build teamwork, ethical awareness and a defense-oriented mindset.",
      fullDescription: `This course aims to give you hands-on experience of an end-to-end penetration test under real-world rules (Rules of Engagement, RoE) while building teamwork, ethical awareness and a defense-oriented mindset. Theory is kept short and focused, reinforced with live demos and team labs, and finally you will apply what you learned in a realistic mini red-team scenario.

Course objective:

• Teach participants how to execute an end-to-end pentest in compliance with RoE
• Improve team role distribution, communication and operational coordination
• Instill a defense-oriented perspective and ethical responsibility

High-level topics:

• RoE and authorization processes: scoping, permission mechanisms, legal and ethical boundaries
• Reconnaissance: target selection, OSINT and asset inventorying
• Scanning and vulnerability discovery: active/passive scanning, service/port enumeration, automated and manual verification
• Verification and impact analysis: safely validating vulnerabilities and assessing potential impact
• Exploit scenarios and simulations: scenario-based validation and discussion in controlled environments
• Pivoting and lateral movement (simulation): identifying how access could be expanded and analyzing impact
• Reporting: documenting technical findings and preparing executive summaries
• Mini red-team scenario: team planning, execution and reporting

Technical and action-oriented exercises:

• Realistic OSINT task: teams collect and prioritize open-source findings under time constraints
• Network discovery challenge: map the target network and identify critical assets
• AD mapping scenario: model the attack surface by collecting Active Directory information
• Pivoting & escalation simulation: plan and report lateral discovery and access expansion
• Short "live" drill: teams rapidly plan and execute a short attack scenario
• Desktop social engineering simulation: controlled phishing awareness exercise
• Log analysis & detection testing: examine SIEM/log samples, filter false positives
• Ransomware-simulation impact assessment: analyze business impact and prioritize response
• Capture-the-flag style short tasks: points-based scoring for motivation

Format & methodology:
Short theory, live demo and team lab cycles. All work is executed in isolated virtual labs. Mini red-team is project-based: teams plan, execute and report.

Learning outcomes:

• Plan, run and report a pentest end-to-end within RoE
• Perform reconnaissance, scanning and verification safely and prioritize findings by impact
• Convert technical findings into clear technical and executive reports
• Improve team communication, role distribution and coordination
• Experience red-team/blue-team dynamics hands-on and develop a defense-oriented mindset

Who should attend:
Aspiring pentesters, security engineers, SOC/IR professionals, network and system administrators, students aiming for a cybersecurity career.

Prerequisites:
Basic networking knowledge (TCP/IP), basic operating system knowledge, command-line experience.

Assessment:
Each team delivers a pentest project: scope, reconnaissance findings, verified vulnerabilities, impact assessment, technical report and executive summary.

Duration & schedule:
Total 24–40 hours (modular delivery; weekend blocks or intensive formats available).

Ethics & safety:
Full compliance with RoE is mandatory. Labs run on isolated virtual infrastructures for training use only.

Training objectives:

• Provide participants with skills to apply end-to-end pentest processes in compliance with RoE
• Develop competencies in intra-team task distribution, communication and operational coordination
• Build defense-oriented perspective and ethical responsibility awareness

Course topics (high level):

• RoE and authorization processes: scope definition, authorization mechanisms and legal/ethical boundaries
• Reconnaissance (Recon): target identification, OSINT and asset inventory creation
• Scanning and vulnerability discovery: active and passive scanning, service/port discovery, automated and manual validation
• Validation and impact analysis: safe validation of vulnerabilities and assessment of potential impacts
• Exploit scenarios and simulation: scenario-based validation and discussion in controlled environments
• Pivoting and lateral movement (simulation): identification of how access can expand and analysis of impacts
• Reporting: detailing technical findings and preparing executive summaries
• Mini red-team scenario: team planning, execution and reporting of results

Technical and action-oriented practices:

• Realistic OSINT task: teams collect and prioritize open source findings within limited time
• Network reconnaissance challenge: mapping target network and identifying critical assets in isolated laboratory
• AD mapping scenario: Active Directory information gathering and attack surface modeling (detection/reporting only)
• Pivoting & access expansion simulation: planning and reporting lateral reconnaissance and access spread
• Short "live" exercises: teams quickly plan and execute attack scenarios
• Social engineering desktop scenario: phishing awareness and reporting
• Log analysis & detection testing: examining SIEM/log samples and separating false-positives
• Ransomware-simulation impact: analyzing impact on business processes and priority response steps
• Capture-the-flag style short tasks: motivation enhancement through point-based evaluation

Training format and methodology:
Progresses through cycles of short theory, live demos and team-based laboratory practices. All work is conducted in isolated virtual laboratories. Mini red-team scenario is project-based; teams plan, execute and present reports.

Learning outcomes (achievements):

• Planning and executing pentest processes from start to finish within RoE framework
• Safely applying reconnaissance, scanning and validation steps while prioritizing findings
• Converting technical findings into understandable reports for both technical teams and managers
• Developing intra-team role distribution, coordination and communication skills
• Experiencing red-team/blue-team dynamics and gaining defense-oriented perspective

Who should attend:
Those wanting to learn pentest, security engineers, SOC/IR specialists, network and system administrators, students and new graduates targeting careers in cybersecurity.

Prerequisites:
Basic network knowledge (TCP/IP), basic operating system knowledge and command line experience.

Assessment:
Each team will present a small pentest project: scope, reconnaissance findings, validated vulnerabilities, impact assessment, technical report and executive summary.

Duration & schedule:
Total 24–40 hours (modular; weekend blocks or intensive program).

Ethics & security commitment:
Full compliance with RoE principles is mandatory throughout training. Laboratory environments are isolated and used for educational purposes only.`,
      duration: "24-40 hours",
      level: "Intermediate-Advanced",
      format: "Live + Lab",
      icon: "Users"
    },
    {
      id: 4,
      title: "Practical Cyber Intelligence (OSINT & Threat Hunting)",
      description: "Learn target profiling, ethical data collection and mapping findings to MITRE ATT&CK framework. Acquire practical skills for defensive and intelligence-oriented workflows.",
      fullDescription: `In this hands-on course you will learn target profiling, ethical data collection from open and closed sources, and how to map findings to the MITRE ATT&CK framework. Theory is concise and goal-oriented, reinforced with live demos, practical OSINT tasks and threat hunting scenarios. By the end of the course you will have practical skills for both defensive and intelligence-oriented workflows.

Course objective:

• Teach participants target-focused profiling and ethical data collection methods
• Enable analysis of collected data using MITRE ATT&CK to identify threat actors' TTPs
• Develop threat hunting practices over SIEM and log sources and convert findings into operational actions

High-level topics:

• OSINT fundamentals: target scoping, source classification, ethical collection from open and closed web
• Tools and automation: Maltego, SpiderFoot, Shodan, theHarvester, Google Dorking, OSINT frameworks and APIs
• Enrichment and validation: cross-source verification, PII/false-positive handling and reliability assessment
• Dark web and forum monitoring: lawful monitoring and transforming signals into actionable intelligence
• MITRE ATT&CK mapping: mapping IOCs and behavior patterns to ATT&CK techniques and building a threat profile
• Threat hunting practices: hypothesis development, SIEM query building, IOC hunting and post-hunt analysis
• Threat reporting: converting technical findings into TI feeds, IOC lists, TTP reports and executive summaries

Technical and action-oriented exercises:

• Target profiling task: produce prioritized enriched profiles for a target organization or persona under time constraints
• Shodan & IoT discovery challenge: quickly identify internet-exposed assets and assess risk
• Dark web monitoring scenario: track forum posts in an isolated environment and classify results
• MITRE mapping workshop: map real-case data to ATT&CK and produce a TTP report
• SIEM hunting drill: write queries against sample log datasets, validate hypotheses and extract IOCs
• Threat intelligence enrichment: enrich IOCs using automated and manual methods and place them into taxonomy
• Capture-the-IOC: short tasks to find critical IOCs, score and report them

Format & methodology:
Short theory segments, live demos and individual/team tasks. Practical exercises run in isolated analysis/test environments (sandbox, VMs). Real-world data, tool integrations and API usage are demonstrated per module.

Learning outcomes:

• Plan and execute target-focused OSINT workflows, validate and prioritize collected data
• Perform TTP and IOC analysis mapped to MITRE ATT&CK and produce threat actor profiles
• Conduct threat hunting on SIEM/log data and craft effective search queries
• Convert collected intelligence into operational actions such as alerts, blocking rules or IOC feeds
• Present technical findings clearly to operational teams and executives

Who should attend:
CTI/OSINT practitioners, SOC and IR team members, security analysts and threat hunters, SOC operators and incident response teams, professionals aiming to specialize in OSINT/CTI.

Prerequisites:
Basic networking and security knowledge (TCP/IP, basic log concepts), command-line and basic scripting skills (Python/Bash) recommended.

Assessment:
Participants complete short OSINT/profiling tasks and submit IOCs, enrichment reports and MITRE mappings.

Duration:
Total 18–30 hours, modular (e.g., 3 weekend sessions or 5 evening sessions).

Ethics & safety:
All data collection activities will be conducted ethically, legally and with required permissions. Protection of collected sensitive data, PII handling and responsible disclosure processes are required.`,
      duration: "18-30 hours",
      level: "Intermediate",
      format: "Live + Lab",
      icon: "Search"
    },
    {
      id: 5,
      title: "Linux & Windows Hardening (Think Like an Attacker, Build Like a Defender)",
      description: "Identify vulnerabilities from an attacker's perspective and harden systems step-by-step. Understand real attack scenarios and build defense correctly.",
      fullDescription: `This hands-on training teaches how to identify vulnerabilities in Linux and Windows systems from an attacker's viewpoint and systematically harden them. Theory is brief; the focus is on understanding real-world attacks and building defense correctly. Participants will see how attackers move inside a system and learn how to protect it like a security engineer.

Course objectives:

• Identify and reduce attack surfaces on Linux and Windows systems
• Detect and mitigate vulnerabilities proactively
• Understand real attack vectors and apply effective hardening policies
• Build the mindset of "think offensively, defend smartly"

Course topics:

• Hardening fundamentals
• Linux security: file permissions, sudo, SSH, journald/log analysis
• Windows security: Active Directory, GPO, PowerShell protection
• Service hardening: Apache/IIS, MySQL/MSSQL, RDP/SSH configuration
• Weak configuration analysis
• Privilege escalation and persistence prevention
• Firewall and network segmentation
• Event detection and monitoring tools
• CIS Benchmark & STIG compliance

Technical exercises:

• Vulnerable VM attack simulation and system hardening
• SSH brute-force detection and restriction
• PowerShell log analysis
• Closing local privilege escalation vectors
• Linux unauthorized access detection via logs
• CIS Benchmark audit and improvement report
• Red-Team vs Blue-Team lab scenario

Course format:
Short theory, live demos, hands-on labs. Individual VMs per participant. All exercises in isolated, secure labs.

Learning outcomes:

• Identify and fix OS-level vulnerabilities
• Apply hardening according to global standards
• Monitor and analyze attacks effectively
• Build tailored hardening checklists

Who should attend:
System administrators, security engineers, SOC/IR teams, pentesters, Red/Blue teamers.

Duration:
20–30 hours (4 intensive days or 6 evenings).

Ethics & safety:
Simulations run in isolated environments. No real-system interaction. Training for defense and awareness only.`,
      duration: "20-30 hours",
      level: "Intermediate",
      format: "Live + Lab",
      icon: "Shield"
    },
    {
      id: 6,
      title: "Practical Mobile Security (Android & iOS)",
      description: "Explore the internal structure of Android and iOS applications, learn attacker techniques, and secure applications. Combine mobile pentest and secure code development skills.",
      fullDescription: `This hands-on training teaches participants how to conduct security tests on mobile applications, identify and remediate vulnerabilities, and apply secure application development principles. Participants will learn to analyze mobile applications from an attacker's perspective while also experiencing defense-oriented development and secure configuration techniques. Throughout the training, analysis, reverse engineering, data manipulation, and secure coding scenarios are applied on real APK and IPA files.

Training objectives:

• Develop mobile application penetration testing skills in Android and iOS environments
• Identify data security, authentication, authorization, and encryption errors
• Analyze and remediate vulnerabilities within the OWASP Mobile Top 10 framework
• Learn secure mobile coding and hardening principles
• Combine attacker and defender perspectives

Course topics:

• Mobile security fundamentals and threat modeling
• OWASP Mobile Top 10 applications
• Android security: APK analysis, Smali, SSL pinning, WebView, root detection
• iOS security: IPA examination, Keychain, jailbreak detection, sandbox, secure storage
• Network security: HTTPS, MITM, proxy analysis, Burp Suite, Frida, Objection
• Secure coding: input validation, data encryption, token management
• Mobile hardening: signing, obfuscation, MDM policies

Technical applications:

• Testing on real APK and IPA files
• Decompile and reverse engineering (APKTool, JADX, Hopper)
• SSL Pinning bypass, root and jailbreak detection tests
• Traffic manipulation with Burp Suite and Frida
• Credential capture and remediation exercises
• Mobile API security tests
• Secure coding applications and Blue-Team scenarios

Training format:
Theory, live demos, and laboratory exercises. Participants are provided with virtual laboratory and emulator environment. A "test – fix – retest" cycle is applied with real mobile applications.

Achievements:

• Conduct security tests on mobile applications
• Identify and validate OWASP Mobile Top 10 vulnerabilities
• Understand SSL Pinning, Root/Jailbreak Detection processes
• Apply secure coding principles
• Establish API and network security controls
• Use application hardening methods

Who should attend:
Mobile developers, security testing specialists, SOC and IR teams, developers wanting to move into mobile security, cybersecurity students and new graduates.

Prerequisites:
Basic network knowledge (TCP/IP, HTTPS), Android Studio or similar environment knowledge, command line experience.

Assessment:
Participants analyze a vulnerable mobile application and make it secure. Final report is prepared: vulnerabilities, solutions, conclusions.

Duration:
20–35 hours (4 intensive days or 6 evening modules).

Ethics and security:
All work is conducted in isolated environments. Interference with real applications is prohibited. Training is for defense and awareness purposes only.`,
      duration: "20-35 hours",
      level: "Intermediate-Advanced",
      format: "Live + Lab",
      icon: "Smartphone"
    }
  ]
};

export const mockWhyChooseUs = {
  tr: [
    {
      id: 1,
      title: "Uzman Kadro",
      description: "10+ yıl deneyimli, uluslararası sertifikalara sahip siber güvenlik uzmanlarımızla çalışıyoruz.",
      icon: "Users"
    },
    {
      id: 2,
      title: "Güncel Teknolojiler",
      description: "En son güvenlik araçlarını kullanıyor, gelişen tehditlere karşı proaktif çözümler üretiyoruz.",
      icon: "Cpu"
    },
    {
      id: 3,
      title: "7/24 Destek",
      description: "Siber tehditler beklemez. Biz de beklemiyoruz. Kesintisiz destek ve hızlı müdahale ile her an yanınızdayız.",
      icon: "Clock"
    },
    {
      id: 4,
      title: "Kanıtlanmış Başarı",
      description: "100+ başarılı proje, %98 müşteri memnuniyeti, 5 yıldır sıfır veri sızıntısı geçmişi ile güvenilir bir iş ortağıyız.",
      icon: "Award"
    }
  ],
  uz: [
    {
      id: 1,
      title: "Mutaxassis Jamoa",
      description: "10+ yillik tajribaga ega, xalqaro sertifikatlarga ega kiber xavfsizlik mutaxassislari bilan ishlaymiz.",
      icon: "Users"
    },
    {
      id: 2,
      title: "Zamonaviy Texnologiyalar",
      description: "Eng so'nggi xavfsizlik vositalarini qo'llab, rivojlanayotgan tahdidlarga qarshi proaktiv yechimlar ishlab chiqaramiz.",
      icon: "Cpu"
    },
    {
      id: 3,
      title: "7/24 Qo'llab-quvvatlash",
      description: "Kiber tahdidlar kutmaydi. Biz ham kutmaymiz. Uzluksiz yordam va tezkor aralashuv bilan har doim yoningizda turamiz.",
      icon: "Clock"
    },
    {
      id: 4,
      title: "Isbotlangan Muvaffaqiyat",
      description: "100+ muvaffaqiyatli loyiha, %98 mijoz mamnuniyati, 5 yil davomida nol ma'lumot sizib chiqishi tarixi bilan ishonchli biznes hamkormiz.",
      icon: "Award"
    }
  ],
  ru: [
    {
      id: 1,
      title: "Команда экспертов",
      description: "Мы работаем с экспертами кибербезопасности с опытом 10+ лет и международными сертификатами.",
      icon: "Users"
    },
    {
      id: 2,
      title: "Современные технологии",
      description: "Используем новейшие инструменты безопасности, создаем проактивные решения против развивающихся угроз.",
      icon: "Cpu"
    },
    {
      id: 3,
      title: "Поддержка 7/24",
      description: "Киберугрозы не ждут. Мы тоже не ждем. С непрерывной поддержкой и быстрым реагированием мы всегда рядом.",
      icon: "Clock"
    },
    {
      id: 4,
      title: "Доказанный успех",
      description: "100+ успешных проектов, 98% удовлетворенности клиентов, 5 лет без единой утечки данных - мы надежный бизнес-партнер.",
      icon: "Award"
    }
  ],
  en: [
    {
      id: 1,
      title: "Expert Team",
      description: "We work with cybersecurity experts with 10+ years of experience and international certifications.",
      icon: "Users"
    },
    {
      id: 2,
      title: "Modern Technologies",
      description: "We use the latest security tools and create proactive solutions against evolving threats.",
      icon: "Cpu"
    },
    {
      id: 3,
      title: "7/24 Support",
      description: "Cyber threats don't wait. Neither do we. With continuous support and rapid response, we're always by your side.",
      icon: "Clock"
    },
    {
      id: 4,
      title: "Proven Success",
      description: "100+ successful projects, 98% customer satisfaction, 5 years of zero data breach history - we are a reliable business partner.",
      icon: "Award"
    }
  ]
};

export const mockCompanyInfo = {
  name: "KiberUP",
  tagline: "Siber Güvenlikte Yeni Nesil Çözümler",
  description: "Özbekistan'ın kiber gücü KiberUP, son teknoloji çözümler ve uzman kadrosuyla işletmenizi dijital tehditlere karşı korur.",
  email: "info@kiberup.com",
  phone: "+998 XX XXX XX XX",
  address: {
    tr: "Taşkent / Özbekistan",
    uz: "Toshkent / O'zbekiston", 
    ru: "Ташкент / Узбекистан",
    en: "Tashkent / Uzbekistan"
  }
};

export const translations = {
  tr: {
    siteName: "KiberUP",
    siteSlogan: "Özbekistan'ın Siber Gücü",
    // Navigation
    home: "Ana Sayfa",
    whyUs: "Neden KiberUP",
    services: "Hizmetlerimiz",
    trainings: "Eğitimlerimiz",
    contact: "İletişim",
    internshipApply: "Staja Başvur",
    
    // Hero Section
    heroTitle: "Siber Güvenlikte Yeni Nesil Çözümler",
    heroDescription: "Özbekistan'ın önde gelen siber güvenlik şirketlerinden KiberUP, son teknoloji çözümler ve uzman kadrosuyla işletmenizi dijital tehditlere karşı korur.",
    discoverServices: "Hizmetlerimizi Keşfedin",
    getInTouch: "İletişime Geçin",
    successfulProjects: "Başarılı Proje",
    yearsExperience: "Yıl Deneyim",
    support: "Destek",
    
    // Why Choose Us
    whyChooseUsTitle: "Neden KiberUP?",
    whyChooseUsDescription: "Çünkü biz yalnızca teoride değil, sahada kanıtlanmış başarılarla öne çıkan bir ekibiz. Türkiye ve uluslararası alanda yürüttüğümüz projelerle, yüzlerce işletmenin güvenliğini sağladık. Uzman kadromuz, son teknoloji çözümleriyle verilerinizi korurken, olası tehditleri daha ortaya çıkmadan önler. KiberUP ile çalıştığınızda sadece bir hizmet değil, sürekli yanında olan bir güven ortağı kazanırsınız.",
    
    // Services
    servicesTitle: "Hizmetlerimiz",
    servicesDescription: "Profesyonel siber güvenlik hizmetlerimizle işletmenizi tüm dijital tehditlere karşı koruyoruz.",
    getDetailedInfo: "Detaylı Bilgi Al",
    features: "Özellikler:",
    
    // Trainings
    trainingsTitle: "Eğitimlerimiz",
    trainingsDescription: "Siber güvenlik alanında kariyer yapmak isteyenler için pratik odaklı eğitim programlarımız.",
    registerTraining: "Eğitime Kayıt Ol",
    duration: "Süre:",
    trainingNote: "Tüm çalışmalar yasal yetki ve izole lab ortamında yürütülür; hedefimiz saldırı tekniklerini öğrenip savunmayı güçlendiren profesyonel etik hacker yetkinliği kazandırmaktır. Tüm eğitimlerimiz yüzde yüz uygulamalıdır.",
    
    // Contact
    contactTitle: "İletişim",
    contactDescription: "Siber güvenlik gözünüzü korkutmasın. Biz yanınızdayız! İhtiyacınıza en uygun çözümleri birlikte planlamak için hemen bizimle iletişime geçin. Tek bir e-posta, işinizi ve verilerinizi güvence altına almak için atacağınız en değerli adım olabilir.",
    email: "E-posta",
    address: "Adres",
    
    // Footer
    footerDescription: "Özbekistan'ın önde gelen siber güvenlik şirketlerinden KiberUP, son teknoloji çözümler ve uzman kadrosuyla işletmenizi dijital tehditlere karşı korur.",
    ourServices: "Hizmetlerimiz",
    ourTrainings: "Eğitimlerimiz",
    rightsReserved: "Tüm hakları saklıdır.",
    privacyPolicy: "Gizlilik Politikası",
    termsOfUse: "Kullanım Şartları",
    aboutUs: "Hakkımızda",
    
    // Footer Services List
    footerServices: [
      "Penetrasyon Testi",
      "Web Uygulama Güvenlik Testleri", 
      "Siber Tehdit İstihbaratı",
      "Malware Analizi",
      "Statik Kod Analizi",
      "DDoS Testleri",
      "5G Güvenlik"
    ],
    
    // Footer Trainings List  
    footerTrainings: [
      "Pratik Web Güvenliği",
      "Pratik Tersine Mühendislik",
      "Pratik Etik Hacker", 
      "Pratik Siber İstihbarat",
      "Linux & Windows Sıkılaştırma",
      "Pratik Mobil Güvenlik"
    ]
  },
  
  uz: {
    siteName: "KiberUP",
    siteSlogan: "O'zbekistonning kiber kuchi",
    // Navigation
    home: "Bosh sahifa",
    whyUs: "Nega KiberUP",
    services: "Xizmatlarimiz",
    trainings: "Ta'limlarimiz",
    contact: "Aloqa",
    internshipApply: "Stajga Ariza",
    
    // Hero Section
   heroTitle: "Kiber Xavfsizlikda Yangi Avlod Yechimlari",
heroDescription: "O'zbekistonning yetakchi kiber xavfsizlik kompaniyalaridan KiberUP, eng so'nggi texnologiya yechimlari va mutaxassis jamoa bilan korxonangizni raqamli tahdidlardan himoya qiladi.",
discoverServices: "Xizmatlarimizni Kashf Eting",
getInTouch: "Bog'laning",
successfulProjects: "Muvaffaqiyatli Loyiha",
yearsExperience: "Yil Tajriba",
support: "Qo'llab-quvvatlash",
    
    // Why Choose Us
    whyChooseUsTitle: "Nega KiberUP?",
    whyChooseUsDescription: "Chunki biz faqat nazariyada emas, dalada isbotlangan muvaffaqiyatlar bilan ajralib turadigan jamoamiz. O'zbekiston va xalqaro miqyosda olib borgan loyihalarimiz bilan yuzlab korxonaning xavfsizligini ta'minladik. Mutaxassis jamoamiz eng so'nggi texnologik yechimlar bilan ma'lumotlaringizni himoya qilib, mumkin bo'lgan tahdidlarni paydo bo'lishidan oldin oldini oladi. KiberUP bilan ishlashda siz nafaqat xizmat, balki doimo yoningizda turuvchi ishonchli hamkor qo'lga kiritasiz.",
    
    // Services
    servicesTitle: "Xizmatlarimiz",
    servicesDescription: "Professional kiber xavfsizlik xizmatlarimiz bilan korxonangizni barcha raqamli tahdidlardan himoya qilamiz.",
    getDetailedInfo: "Batafsil Ma'lumot Oling",
    features: "Xususiyatlari:",
    
    // Trainings
    trainingsTitle: "Ta'limlarimiz",
    trainingsDescription: "Kiberxavfsizlik sohasida martaba orttirishni istaganlar uchun amaliyotga yo'naltirilgan o'quv dasturlari.",
    registerTraining: "Ta'limga Ro'yxatdan O'ting",
    duration: "Davomiyligi:",
    trainingNote: "Barcha ishlar qonuniy ruxsat va alohida laboratoriya muhitida amalga oshiriladi; maqsadimiz hujum usullarini o'rganib himoyani mustahkamlaydigan professional axloqiy xaker malakasini berish. Barcha ta'limlarimiz yuz foiz amaliy.",
    
    // Contact
    contactTitle: "Aloqa",
    contactDescription: "Kiber xavfsizlik sizni qo'rqitmasin. Biz yoningizedamiz! Ehtiyojingizga eng mos yechimlarni birgalikda rejalashtirish uchun darhol biz bilan bog'laning. Bitta elektron pochta xabari ishingiz va ma'lumotlaringizni himoya qilish uchun qo'yadigan eng qimmatli qadam bo'lishi mumkin.",
    email: "Elektron pochta",
    address: "Manzil",
    
    // Footer
    footerDescription: "O'zbekistonning yetakchi kiber xavfsizlik kompaniyalaridan KiberUP, eng so'nggi texnologiya yechimlari va mutaxassis jamoa bilan korxonangizni raqamli tahdidlardan himoya qiladi.",
    ourServices: "Xizmatlarimiz",
    ourTrainings: "Ta'limlarimiz",
    rightsReserved: "Barcha huquqlar himoyalangan.",
    privacyPolicy: "Maxfiylik Siyosati",
    termsOfUse: "Foydalanish Shartlari",
    aboutUs: "Biz Haqimizda",
    
    // Footer Services List
    footerServices: [
      "Penetratsiya Testi",
      "Veb Ilova Xavfsizlik Testlari",
      "Kiber Tahdid Razvedkasi", 
      "Zararli Dastur Tahlili",
      "Statik Kod Tahlili",
      "DDoS Testlari",
      "5G Xavfsizlik"
    ],
    
    // Footer Trainings List
    footerTrainings: [
      "Amaliy Veb Xavfsizligi",
      "Amaliy Teskari Muhandislik",
      "Amaliy Axloqiy Xaker",
      "Amaliy Kiber Razvedka", 
      "Linux va Windows Qattiqlashtiruv",
      "Amaliy Mobil Xavfsizlik"
    ]
  },
  
  ru: {
    siteName: "KiberUP",
    siteSlogan: "Кибер-сила Узбекистана",
    // Navigation
    home: "Главная",
    whyUs: "Почему KiberUP",
    services: "Наши услуги",
    trainings: "Обучение",
    contact: "Контакты",
    internshipApply: "Подать заявку на стажировку",
    
    // Hero Section
    heroTitle: "Решения нового поколения в кибербезопасности",
    heroDescription: "KiberUP - одна из ведущих компаний кибербезопасности Узбекистана, защищает ваш бизнес от цифровых угроз с помощью передовых технологических решений и команды экспертов.",
    discoverServices: "Изучите наши услуги",
    getInTouch: "Связаться с нами",
    successfulProjects: "Успешных проектов",
    yearsExperience: "Лет опыта",
    support: "Поддержка",
    
    // Why Choose Us
    whyChooseUsTitle: "Почему KiberUP?",
    whyChooseUsDescription: "Потому что мы команда, которая выделяется не только теорией, но и доказанными успехами на практике. Благодаря нашим проектам в Узбекистане и на международном уровне мы обеспечили безопасность сотен предприятий. Наша команда экспертов защищает ваши данные новейшими технологическими решениями, предотвращая возможные угрозы еще до их появления. Работая с KiberUP, вы получаете не просто услугу, а надежного партнера, который всегда рядом.",
    
    // Services
    servicesTitle: "Наши услуги",
    servicesDescription: "Защищаем ваш бизнес от всех цифровых угроз с помощью профессиональных услуг кибербезопасности.",
    getDetailedInfo: "Получить подробную информацию",
    features: "Особенности:",
    
    // Trainings
    trainingsTitle: "Обучение",
    trainingsDescription: "Практико-ориентированные учебные программы для тех, кто хочет сделать карьеру в области кибербезопасности.",
    registerTraining: "Записаться на обучение",
    duration: "Продолжительность:",
    trainingNote: "Все работы проводятся с законными полномочиями и в изолированной лабораторной среде; наша цель - обучить методам атак и укрепить защиту, развивая компетенции профессиональных этичных хакеров. Все наши тренинги на 100% практические.",
    
    // Contact
    contactTitle: "Контакты",
    contactDescription: "Пусть кибербезопасность вас не пугает. Мы с вами! Свяжитесь с нами прямо сейчас, чтобы вместе спланировать наиболее подходящие для ваших потребностей решения. Одно электронное письмо может стать самым ценным шагом для защиты вашего бизнеса и данных.",
    email: "Электронная почта",
    address: "Адрес",
    
    // Footer
    footerDescription: "KiberUP - одна из ведущих компаний кибербезопасности Узбекистана, защищает ваш бизнес от цифровых угроз с помощью передовых технологических решений и команды экспертов.",
    ourServices: "Наши услуги",
    ourTrainings: "Обучение",
    rightsReserved: "Все права защищены.",
    privacyPolicy: "Политика конфиденциальности",
    termsOfUse: "Условия использования",
    aboutUs: "О нас",
    
    // Footer Services List
    footerServices: [
      "Тестирование на проникновение",
      "Тестирование безопасности веб-приложений",
      "Аналитика киберугроз",
      "Анализ вредоносного ПО",
      "Статический анализ кода",
      "DDoS тестирование",
      "5G безопасность"
    ],
    
    // Footer Trainings List
    footerTrainings: [
      "Практическая веб-безопасность",
      "Практическая реверс-инженерия",
      "Практический этичный хакинг",
      "Практическая киберразведка",
      "Усиление Linux и Windows",
      "Практическая мобильная безопасность"
    ]
  },
  
  en: {
    siteName: "KiberUP",
    siteSlogan: "Uzbekistan's Cyber Power",
    // Navigation
    home: "Home",
    whyUs: "Why KiberUP",
    services: "Our Services",
    trainings: "Training",
    contact: "Contact",
    internshipApply: "Apply for Internship",
    
    // Hero Section
    heroTitle: "Next Generation Solutions in Cybersecurity",
    heroDescription: "KiberUP, one of Uzbekistan's leading cybersecurity companies, protects your business from digital threats with cutting-edge technology solutions and expert team.",
    discoverServices: "Discover Our Services",
    getInTouch: "Get In Touch",
    successfulProjects: "Successful Projects",
    yearsExperience: "Years Experience",
    support: "Support",
    
    // Why Choose Us
    whyChooseUsTitle: "Why KiberUP?",
    whyChooseUsDescription: "Because we are a team that stands out not only in theory but with proven successes in the field. Through our projects in Turkey and internationally, we have secured the safety of hundreds of businesses. Our expert team protects your data with cutting-edge technological solutions while preventing potential threats before they emerge. When you work with KiberUP, you gain not just a service, but a trusted partner who is always by your side.",
    
    // Services
    servicesTitle: "Our Services",
    servicesDescription: "We protect your business from all digital threats with our professional cybersecurity services.",
    getDetailedInfo: "Get Detailed Information",
    features: "Features:",
    
    // Trainings
    trainingsTitle: "Training Programs",
    trainingsDescription: "Practice-oriented training programs for those who want to make a career in cybersecurity.",
    registerTraining: "Register for Training",
    duration: "Duration:",
    trainingNote: "All work is conducted with legal authority and in an isolated laboratory environment; our goal is to learn attack techniques and strengthen defense by developing professional ethical hacker competencies. All our trainings are 100% practical.",
    
    // Contact
    contactTitle: "Contact",
    contactDescription: "Don't let cybersecurity intimidate you. We're here with you! Contact us right away to plan the most suitable solutions for your needs together. A single email could be the most valuable step you take to secure your business and data.",
    email: "Email",
    address: "Address",
    
    // Footer
    footerDescription: "KiberUP, one of Uzbekistan's leading cybersecurity companies, protects your business from digital threats with cutting-edge technology solutions and expert team.",
    ourServices: "Our Services",
    ourTrainings: "Training Programs",
    rightsReserved: "All rights reserved.",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
    aboutUs: "About Us",
    
    // Footer Services List
    footerServices: [
      "Penetration Testing",
      "Web Application Security Tests",
      "Cyber Threat Intelligence",
      "Malware Analysis",
      "Static Code Analysis", 
      "DDoS Testing",
      "5G Security"
    ],
    
    // Footer Trainings List
    footerTrainings: [
      "Practical Web Security",
      "Practical Reverse Engineering",
      "Practical Ethical Hacking",
      "Practical Cyber Intelligence",
      "Linux & Windows Hardening",
      "Practical Mobile Security"
    ]
  }
};
